// English language package
export default {
  modelConfig: {
    searchPlaceholder: 'Please enter model name to search',
    search: 'Search',
    vad: 'Voice Activity Detection',
    asr: 'Automatic Speech Recognition',
    llm: 'Large Language Model',
    vllm: 'Visual Large Language Model',
    intent: 'Intent Recognition',
    tts: 'Text To Speech',
    memory: 'Memory',
    rag: 'Knowledge Base',
    modelId: 'Model ID',
    modelName: 'Model Name',
    provider: 'Provider',
    unknown: 'Unknown',
    isEnabled: 'Enabled',
    isDefault: 'Default',
    action: 'Action',
    voiceManagement: 'Voice Management',
    edit: 'Edit',
    duplicate: 'Duplicate',
    delete: 'Delete',
    deselectAll: 'Deselect All',
    select: 'Select',
    selectAll: 'Select All',
    add: 'Add',
    selectModelsFirst: 'Please select models to delete first',
    confirmBatchDelete: 'Are you sure you want to delete selected models?',
    confirmDelete: 'Are you sure you want to delete this model?',
    batchDeleteSuccess: 'Batch delete successful',
    partialDeleteFailed: 'Partial delete failed',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Delete failed',
    deleteCancelled: 'Delete cancelled',
    duplicateSuccess: 'Duplicate successful',
    duplicateFailed: 'Duplicate failed',
    saveSuccess: 'Saved successfully',
    saveFailed: 'Save failed',
    addSuccess: 'Added successfully',
    addFailed: 'Add failed',
    fetchModelsFailed: 'Failed to fetch models',
    enableSuccess: 'Enabled successfully',
    disableSuccess: 'Disabled successfully',
    operationFailed: 'Operation failed',
    setDefaultSuccess: 'Set as default successfully',
    activationStatus: 'Activation Status',
    activated: 'Activated',
    unactivated: 'Unactivated',
    activationDate: 'Activation Date',
    expirationDate: 'Expiration Date',
    batchOperation: 'Batch Operation',
    batchActivate: 'Batch Activate',
    batchDeactivate: 'Batch Deactivate',
    batchActivateSuccess: 'Batch activation successful',
    batchDeactivateSuccess: 'Batch deactivation successful',
    itemsPerPage: '{items} items/page',
    firstPage: 'First',
    prevPage: 'Prev',
    nextPage: 'Next',
    totalRecords: 'Total {total} records',
    loading: 'Loading...',
    viewQuota: 'View Quota',
    quotaInfo: 'Account Quota Info',
    totalQuota: 'Total Quota',
    usedQuota: 'Used Quota',
    remainingQuota: 'Remaining Quota',
    refreshQuota: 'Refresh Quota',
    checkKeyFirst: 'Please configure and save API Key first',
    enabled: 'Enabled',
    disabled: 'Disabled',
    default: 'Default',
    nonDefault: 'Non-default',
    dynamicParams: 'Dynamic Parameters',
    noDynamicParams: 'No dynamic parameters',
    refresh: 'Refresh',
    fetchDetailFailed: 'Failed to fetch model details',
    usageProgress: 'Usage Progress',
    noQuotaConfigured: 'Total quota not configured. Please set the model total quota in the edit page first.'
  },
  modelConfigDialog: {
    addModel: 'Add Model',
    editModel: 'Edit Model',
    viewDetail: 'Model Details',
    duplicateModel: 'Duplicate Model',
    copySuffix: '_copy',
    modelInfo: 'Model Information',
    modelType: 'Model Type',
    status: 'Status',
    enable: 'Enabled',
    setDefault: 'Set Default',
    modelId: 'Model ID',
    enterModelId: 'Leave empty to generate automatically',
    modelName: 'Model Name',
    enterModelName: 'Please enter model name',
    modelCode: 'Model Code',
    enterModelCode: 'Please enter model code',
    supplier: 'Supplier',
    selectSupplier: 'Please select',
    sortOrder: 'Sort Order',
    enterSortOrder: 'Please enter sort order',
    docLink: 'Doc Link',
    enterDocLink: 'Please enter doc link',
    totalQuota: 'Total Quota Token',
    enterTotalQuota: 'Please enter total quota (0 for unlimited)',
    threshold: 'Alert Threshold (%)',
    enterThreshold: 'Please enter alert threshold (0-100)',
    usedQuota: 'Used Quota',
    remainingQuota: 'Remaining Quota',
    remark: 'Remark',
    enterRemark: 'Please enter model remark',
    callInfo: 'Call Information',
    enterJsonExample: 'Please enter JSON format (e.g. {"key":"value"})',
    save: 'Save'
  },
  TtsModel: {
    voiceManagement: 'Voice Management',
    addVoice: 'Add Voice',
    searchPlaceholder: 'Search by voice name',
    voiceName: 'Voice Name',
    voiceId: 'Voice ID',
    isDefault: 'Default',
    remark: 'Remark',
    action: 'Action',
    confirmDelete: 'Are you sure you want to delete this voice?',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Delete failed',
    voicePrint: 'Voice Print',
    referenceText: 'Reference Text',
    referenceAudio: 'Reference Audio',
    placeholder: 'Please select'
  },
  editVoiceDialog: {
    addVoice: 'Add Voice',
    editVoice: 'Edit Voice',
    voiceName: 'Voice Name',
    enterVoiceName: 'Please enter voice name',
    voiceId: 'Voice ID',
    enterVoiceId: 'Please enter voice ID',
    isDefault: 'Default',
    remark: 'Remark',
    enterRemark: 'Please enter remark',
    voicePrint: 'Voice Print',
    enterVoicePrint: 'Please enter voice print',
    referenceText: 'Reference Text',
    enterReferenceText: 'Please enter reference text',
    referenceAudio: 'Reference Audio',
    enterReferenceAudio: 'Please enter reference audio URL',
    save: 'Save',
    cancel: 'Cancel',
    saveSuccess: 'Saved successfully',
    saveFailed: 'Save failed',
    requiredVoiceName: 'Voice name is required',
    requiredVoiceId: 'Voice ID is required',
    defaultLanguageType: 'en-US'
  },
  voicePrint: {
    title: 'Voice Print Management',
    add: 'Add Voice Print',
    name: 'Name',
    content: 'Content',
    action: 'Action',
    confirmDelete: 'Are you sure you want to delete this voice print?',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Delete failed',
    loading: 'Loading'
  },
  common: {
    back: 'Back',
    ignore: 'Ignore',
    critical: 'Critical',
    tips: 'Tips',
    close: 'Close',
    comingSoon: 'Coming Soon',
    edit: 'Edit',
    view: 'View',
    create: 'Create',
    save: 'Save',
    delete: 'Delete',
    confirmDelete: 'Are you sure you want to delete?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    reset: 'Reset',
    submit: 'Submit',
    active: 'Active',
    inactive: 'Inactive',
    inUse: 'In Use',
    cancelled: 'Cancelled',
    frozen: 'Frozen',
    freeze: 'Freeze',
    unfreeze: 'Unfreeze',
    cancelAccount: 'Deactivate',
    confirmCancelAccount: 'Are you sure you want to deactivate this user? The user will not be able to log in.',
    confirmFreeze: 'Are you sure you want to freeze this user? The user will not be able to log in.',
    confirmUnfreeze: 'Are you sure you want to unfreeze this user? The user will be able to log in normally.',
    confirmBatchFreeze: 'Are you sure you want to freeze the selected users?',
    confirmBatchUnfreeze: 'Are you sure you want to unfreeze the selected users?',
    confirmBatchCancelAccount: 'Are you sure you want to deactivate the selected users?',
    freezeSuccess: 'Freeze successful',
    unfreezeSuccess: 'Unfreeze successful',
    cancelAccountSuccess: 'Deactivation successful',
    batchFreezeSuccess: 'Batch freeze successful',
    batchUnfreezeSuccess: 'Batch unfreeze successful',
    batchCancelAccountSuccess: 'Batch deactivation successful',
    status: 'Status',
    before: 'Before',
    after: 'After',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    add: 'Add',
    addRoot: 'Add Root Permission',
    refresh: 'Refresh',
    query: 'Query',
    search: 'Search',
    loading: 'Loading...',
    placeholder: 'Please select',
    selectPlaceholder: 'Please select',
    view: 'View',
    viewMore: 'View More',
    tips: 'Tips',
    confirm: 'Confirm',
    cancel: 'Cancel',
    warning: 'Warning',
    saveSuccess: 'Save successful',
    saveFailed: 'Save failed',
    change: 'Change',
    loadFailed: 'Load failed',
    fetchFailed: 'Fetch failed',
    exportSuccess: 'Export successful',
    exportFailed: 'Export failed',
    export: 'Export',
    exportLogs: 'Export Logs',
    noData: 'No data',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Delete failed',
    deleteConfirm: 'Are you sure you want to delete?',
    unbind: 'Unbind',
    unbindSuccess: 'Unbound successfully',
    unbindFailed: 'Unbind failed',
    bindSuccess: 'Bound successfully',
    bindFailed: 'Bind failed',
    copySuccess: 'Copy successful',
    copyFailed: 'Copy failed',
    batchDelete: 'Batch Delete',
    batchDeleteSuccess: 'Batch delete successful',
    batchDeleteFailed: 'Batch delete failed',
    batchDeleteConfirm: 'Are you sure you want to delete {count} selected items?',
    batchOperation: 'Batch Operation',
    operationSuccess: 'Operation successful',
    operationFailed: 'Operation failed',
    getDataFailed: 'Failed to get data',
    canceled: 'Canceled',
    id: 'ID',
    remark: 'Remark',
    remarkLength: 'Remark length cannot exceed 200 characters',
    all: 'All',
    online: 'Online',
    offline: 'Offline',
    operation: 'Operation',
    operations: 'Operations',
    actions: 'Actions',
    action: 'Action',
    detail: 'Detail',
    user: 'User',
    stopped: 'Stopped',
    to: 'To',
    startDate: 'Start Date',
    endDate: 'End Date',
    process: 'Process',
    more: 'More',
    today: 'Today',
    week: 'Week',
    month: 'Month',
    quarter: 'Quarter',
    year: 'Year',
    custom: 'Custom',
    lastWeek: 'Last Week',
    lastMonth: 'Last Month',
    last3Months: 'Last 3 Months',
    proportion: 'Proportion',
    dateRange: 'Date Range',
    rank: 'Rank',
    name: 'Name',
    description: 'Description',
    descriptionPlaceholder: 'Please enter description',
    user: 'User',
    username: 'Username',
    processSuccess: 'Processed successfully',
    processFailed: 'Process failed',
    clearSuccess: 'Cleared successfully',
    clearFailed: 'Clear failed',
    clear: 'Clear',
    copy: 'Copy',
    copySuccess: 'Copied successfully',
    copyFailed: 'Copy failed',
    expandLevel1: 'Expand Level 1',
    checkAll: 'Check All',
    checkNone: 'Check None',
    invertCheck: 'Invert',
    pleaseInput: 'Please input ',
    sort: 'Sort',
    yes: 'Yes',
    no: 'No',
    unknown: 'Unknown',
    warning: 'Warning',
    enterPlaceholder: 'Please enter',
    selectPlaceholder: 'Please select',
    pause: 'Pause',
    resume: 'Resume',
    retry: 'Retry',
    completed: 'Completed',
    type: 'Type',
    content: 'Content',
    logs: 'Logs'
  },
  dashboard: {
    title: 'Control Center',
    userCount: 'Total Users',
    deviceCount: 'Total Devices',
    resourceUsage: 'Resource Usage',
    pendingAlerts: 'Pending Alerts',
    resourceTrend: 'Resource Usage Trend',
    deviceStatus: 'Device Status Distribution',
    deviceVersion: 'Device Version',
    recentActivities: 'Recent Activities',
    systemStatus: 'System Status',
    quickActions: 'Quick Actions',
    createUser: 'Create User',
    createAgent: 'Create Agent',
    chatHistory: 'Chat History',
    agentCount: 'Total Agents',
    digitalCollectionCount: 'Digital Collections',
    badgeCount: 'Badges Issued',
    badgeGrowth: 'Badge Growth',
    bindDevice: 'Bind Device',
    anomaly: 'Anomaly',
    growthTrend: 'Growth Trend',
    userGrowth: 'User Growth',
    deviceGrowth: 'Device Growth',
    agentGrowth: 'Agent Growth',
    digitalCollectionGrowth: 'Collection Growth',
    quotaManagement: 'Quota Management',
    customize: 'Customize',
    customizeQuickActions: 'Customize Quick Actions',
    selectQuickActions: 'Select quick actions to display on home',
    maxQuickActions: 'Select up to 8 quick actions',
    userList: 'User List',
    deviceList: 'Device List',
    systemLogs: 'System Logs',
    notificationManagement: 'Notification Management',
    alarmManagement: 'Alarm Management',
    serverMonitor: 'Server Monitor',
    systemConfig: 'System Config',
    days: 'days',
    viewMore: 'View More',
    detailedMonitoring: 'Detailed Monitoring',
    trendUp: '+12%',
    trendUpLow: '+8%',
    trendDown: '-5%',
    trendUpAlert: '+3',
    increase: '+',
    decrease: '-',
    days7: '7 days',
    days30: '30 days',
    days90: '90 days',
    apiCalls: 'API Calls',
    storageUsage: 'Storage Usage(MB)',
    online: 'Online',
    offline: 'Offline',
    maintenance: 'Maintenance',
    error: 'Error',
    apiService: 'API Service',
    database: 'Database',
    messageQueue: 'Message Queue',
    fileStorage: 'File Storage',
    days: 'days',
    hours: 'hours',
    minutes: 'minutes',
    justNow: 'Just now',
    userCreatedAccount: 'User {username} created a new account',
    deviceOnline: 'Device {mac} is online',
    userQuotaAdjusted: 'User {username} quota adjusted',
    systemBackupCompleted: 'System completed scheduled backup',
    running: 'Running',
    stopped: 'Stopped',
    daysAgo: '{days} days ago',
    hoursAgo: '{hours} hours ago',
    minutesAgo: '{minutes} minutes ago',
    weekday1: 'Mon',
    weekday2: 'Tue',
    weekday3: 'Wed',
    weekday4: 'Thu',
    weekday5: 'Fri',
    weekday6: 'Sat',
    weekday7: 'Sun',
    deviceOnlineMsg: 'Device {mac} is online',
    userQuotaAdjustedMsg: 'User {username} quota adjusted',
    systemBackupCompletedMsg: 'System completed scheduled backup'
  },
  layout: {
    systemTitle: 'AI Agent Management System',
    home: 'Control Center',
    userManagement: 'User Management',
    agentManagement: 'Agent Management',
    deviceManagement: 'Device Management',
    resourceManagement: 'Resource Management',
    activityManagement: 'Activity Management',
    communityActivity: 'Community Content',
    activityMemorial: 'Activity Memorial',
    rightsShop: 'Rights Shop',
    rightsExchange: 'Exchange Records',
    systemManagement: 'System Management',
    userList: 'User List',
    userGroup: 'User Group',
    rolePermissions: 'Role Permissions',
    permissionManagement: 'Permission Management',
    deviceList: 'Device List',
    deviceBind: 'Device Binding',
    firmwareUpgrade: 'Firmware Upgrade',
    deviceLogs: 'Device Logs',

    resourceOverview: 'Overview & Monitoring',
    quotaManagement: 'Quota Management',
    usageReport: 'Usage Report',
    modelManagement: 'Model Management',
    quotaDetail: 'Quota Detail',
    quotaPolicy: 'Quota Policy',
    usageDetails: 'Usage Details',
    usageAmount: 'Usage Amount',
    usageTrend: 'Usage Trend',
    operationLog: 'Log Management',
    notificationManagement: 'Notification Management',
    alarmManagement: 'Alarm Management',
    serverMonitor: 'Server Monitor',
    jobManagement: 'Job Management',
    jobLog: 'Job Log',
    systemConfig: 'System Config',
    profile: 'Profile',
    settings: 'Settings',
    logout: 'Logout',
    expandMenu: 'Expand Menu',
    collapseMenu: 'Collapse Menu',
    admin: 'Admin',
    logoutSuccess: 'Logout successful',
    logoutError: 'Logout failed'
  },
  analysis: {
    dataAnalysis: 'Data Analysis',
    overview: 'Overview',
    overviewDesc: 'Global core metrics summary for business scale and campaign stage comparison',
    userAnalysis: 'User Analysis',
    userAnalysisDesc: 'Analyze acquisition scale, growth trends, and full conversion funnel',
    productAnalysis: 'Product Analysis',
    productAnalysisDesc: 'Product visits, conversion rate and other metrics',
    collectionAnalysis: 'Collection Analysis',
    collectionAnalysisDesc: 'Collection popularity and multi-series completion comparison',
    badgeAnalysis: 'Badge Analysis',
    badgeAnalysisDesc: 'Campaign badge data review with funnel and stage comparison',
    userActivity: 'User Activity',
    userActivityDesc: 'User activity and channel contribution analysis',
    comingSoon: 'Coming Soon',
    placeholderTip: 'This module is under development, stay tuned',
    overviewPlan: 'Will include: 5 business KPI cards, 3-stage comparison chart, 4 mini sparklines',
    userAnalysisPlan: 'Will include: growth dual-axis chart, conversion funnel, user segmentation',
    productVisitConversion: 'Product Visits & Conversion',
    productAnalysisPlan: 'Will include: visit trend, conversion funnel, product ranking',
    collectionTrendRanking: 'Collection Trend & Ranking',
    collectionAnalysisPlan: 'Will include: daily collection trend, product ranking, series analysis',
    badgeIssuanceFunnel: 'Badge Issuance & Funnel',
    badgeAnalysisPlan: 'Will include: issuance trend, 3-type comparison, collection funnel',
    coreMetrics: 'Core Metrics',
    dimension: 'Dimension',
    timeRange: 'Time Range',
    today: 'Today',
    week: '7 Days',
    month: '30 Days',
    quarter: '90 Days',
    year: '1 Year',
    custom: 'Custom',
    granularity: 'Granularity',
    granularityAuto: 'Auto',
    granularityHour: 'Hour',
    granularityDay: 'Day',
    granularityWeek: 'Week',
    granularityMonth: 'Month',
    rangeSeparator: 'To',
    startDate: 'Start Date',
    endDate: 'End Date',
    refresh: 'Refresh',
    anomaly: 'Anomaly',
    anomalyTip: 'Abnormal fluctuation detected',
    yesterday: 'Yesterday',
    back: 'Back',
    noRetentionData: 'No retention data',
    retentionRate: 'Retention Rate',
    noFunnelData: 'No funnel data',
    funnelValue: 'Users',
    funnelOverallRate: 'Overall Rate',
    funnelDropOff: 'Drop-off',
    funnel: 'Funnel',
    loading: 'Loading...',
    noData: 'No data',
    coreMetricsCard: 'Core Metrics',
    miniTrend: 'Mini Trend',
    growthDualAxis: 'Growth Dual-Axis Trend',
    conversionFunnel: 'Conversion Funnel',
    userSegmentationChart: 'User Segmentation',
    retentionMatrix: 'Retention Matrix',
    dailyTrend: 'Daily Trend',
    issuanceTrend: 'Issuance Trend',
    badgeFunnel: 'Collection Funnel',
    visitTrend: 'Visit Trend',
    productRanking: 'Product Ranking',
    deviceActivity: 'Device Activity Analysis',
    deviceActivityDesc: 'Device activity by days since last use, full-scope stats unaffected by time range',
    firmwareDist: 'Firmware Version Distribution',
    deviceRenameStatus: 'Device Rename Status',
    userDeviceDist: 'User Device Count Distribution',
    collectionRanking: 'Collection Ranking',
    collectionRankingDesc: 'Top10 items by acquisitions within the time range, synced with daily trend',
    seriesRanking: 'Series Ranking',
    seriesRankingDesc: 'Full-scope Top10 series by collection acquisitions, unaffected by time filter; click a bar for series details',
    nfcUserRanking: 'NFC User Ranking',
    nfcProductRanking: 'NFC Product Ranking',
    nfcSwipeRanking: 'NFC Swipe Ranking',
    nfcUserDaysRanking: 'NFC Usage Days Ranking',
    badgeRanking: 'Badge Ranking',
    rank: 'Rank',
    rankName: 'Name',
    rankValue: 'Value',
    rankUnit: 'Unit',
    rankProportion: 'Share',
    topN: 'TopN',
    overallConversion: 'Overall Conversion',
    totalUsers: 'Total Users',
    totalDevices: 'Cumulative Devices',
    totalNfc: 'Cumulative Swipes',
    totalCollections: 'Cumulative Collections',
    totalBadges: 'Cumulative Badges',
    dimUser: 'User',
    dimDevice: 'Device',
    dimAgent: 'Agent',
    dimCollection: 'Collection',
    dimNfc: 'NFC Swipe',
    dimBadge: 'Badge',
    allBadgeTypes: 'All Types',
    badgeIssuance: 'Badge Issuance',
    trendCompare: 'Trend Comparison',
    chartType: 'Chart Type',
    lineChart: 'Line Chart',
    barChart: 'Bar Chart',
    metricUser: 'New Users',
    metricDevice: 'New Devices',
    metricNfc: 'NFC Swipes',
    metricCollection: 'Collections',
    metricBadge: 'Badges',
    metricDau: 'Active DAU',
    funnelType: 'Funnel Type',
    funnelUserAcquisition: 'User Acquisition',
    funnelBadgeCollection: 'Badge Collection',
    segmentNewInactive: 'New Inactive',
    segmentActiveNoInteract: 'Active No Interact',
    segmentShallow: 'Shallow Active',
    segmentDeep: 'Deep Active',
    segmentChurned: 'Churned',
    cohortDate: 'Cohort Date',
    cohortSize: 'Cohort Size',
    dayOffset: 'Day N',
    retainedUsers: 'Retained Users',
    peakDau: 'Peak DAU',
    avgDau: 'Avg DAU',
    wau: 'Weekly Active (WAU)',
    activityOverview: 'Overall Activity Analysis',
    channelContribution: 'Channel Contribution',
    channelContributionTip: 'NFC / Collection / Badge contribution to active users',
    nextDayRetention: 'Next-Day Retention',
    avgActivityLevel: 'Avg Activity Level',
    activePenetration: 'Active Penetration',
    nextDayRetentionDesc: 'Avg ratio of users active on both consecutive days',
    avgActivityLevelDesc: 'Avg actions per active user-day',
    activePenetrationDesc: 'Distinct active users over total users',
    dauTrendTitle: 'DAU Trend',
    dauTrendTip: 'Daily distinct active users over the selected range',
    peakLabel: 'Peak',
    dauChannelStack: 'DAU Channel Stack',
    dauChannelStackTip: 'Daily active users stacked by NFC / Collection / Badge',
    channelNfc: 'NFC Swipe',
    channelCollection: 'Collection',
    channelBadge: 'Badge',
    dauUnit: 'users',
    activityAssessment: 'Retention & Activity Assessment',
    seriesAnalysisTitle: 'Series Analysis',
    seriesUsers: 'Series Users',
    fullSetWithoutHidden: 'Full Set (No Hidden)',
    hiddenOwners: 'Hidden Owners',
    fullSetWithHidden: 'Full Set (With Hidden)',
    seriesAnalysisPercentOfUsers: '{p} of series users',
    itemCollectorsTitle: 'Item Collectors',
    itemCollectorsTip: 'Distinct holders per item; hidden items shown in orange',
    holdingDistributionTitle: 'Holding Distribution',
    holdingDistributionTip: 'Users grouped by holding count range',
    collectors: 'Collectors',
    userCount: 'Users',
    hiddenTag: 'Hidden',
    // ---- Overview ----
    dimChat: 'AI Chats',
    todayNewUsers: 'New Users Today',
    todayNfcSwipes: 'NFC Swipes Today',
    todayChats: 'Chats Today',
    todayCollections: 'Collections Today',
    todayBadges: 'Badges Today',
    // ---- User Activity ----
    mau: 'Monthly Active Users (MAU)',
    stickiness: 'Stickiness (DAU/MAU)',
    newOldComposition: 'New vs Returning Users',
    newOldCompositionTip: 'Daily active user composition by registration age',
    segNewUser: 'Same-day New Users',
    segD1To30: 'Registered 1-30 Days',
    segD31To90: 'Registered 31-90 Days',
    segD90Plus: 'Registered 90+ Days',
    weekReturnRate: '7-Day Return Rate',
    weekReturnRateDesc: 'Average share of active users returning within the following 7 days',
    timesUnit: 'times',
    dauKpiDesc: 'Peak/avg DAU share the trend chart range; WAU/MAU are rolling 7/30-day deduplicated active users; stickiness = avg DAU/MAU×100%',
    dauTrendDesc: 'Daily deduplicated active users (DAU) curve with peak marked in red; active = user with any NFC swipe / collection / badge action that day',
    activityOverviewDesc: 'Deduplicated active share by channel (multi-channel users counted repeatedly) and retention assessment; next-day retention / 7-day return are period averages, penetration = active users / total registered users',
    activityAssessmentTip: 'Retention and return assessment based on complete daily snapshots',
    newOldDesc: 'Daily DAU stacked by tenure: same-day signup / 1-30d / 31-90d / 90d+, showing the evolution of new vs. old active structure',
    channelStackDesc: 'Daily DAU stacked by NFC / collection / badge channels (multi-channel users counted repeatedly), identifying the main growth driver',
    retentionAvgLabel: 'Avg retention (matured cohorts)',
    retentionMatrixDesc: 'Each row is a signup-date cohort (size in brackets), each column is the share still active on day D+N; rate = active on D+N / cohort size, "-" means not yet reached; data comes from daily 00:15 complete-day snapshots',
    snapshotNote: 'This module is based on complete natural-day snapshots (generated daily at 00:10/00:15); real-time data for today is not included and appears the next morning',
    // ---- User Analysis ----
    levelDistribution: 'User Level Distribution',
    pointsDistribution: 'Points Balance Distribution',
    registerTrend: 'Registrations (Last 12 Months)',
    // ---- User Behavior Combination ----
    behaviorCombo: 'User Behavior Combination',
    behaviorComboTip: 'Full-scope stats of device binding and digital collection combinations; hover for details',
    behaviorFeature: 'Behavior',
    behaviorBasicDesc: 'Registered only: no device bound, no digital collection',
    behaviorDeviceOnlyDesc: 'Device bound, no digital collection yet',
    behaviorOnlineOnlyDesc: 'No device, but owns digital collections',
    behaviorFullDesc: 'Full deep users: device bound and digital collections acquired',
    userSegmentationTip: 'Deep active / shallow active / new inactive / churned users based on activity within the time range; hover a slice for user count and behavior profile',
    segDeepDesc: 'Max daily actions >= 3 in range, highly engaged',
    segShallowDesc: 'Active in range, but max daily actions < 3',
    segNewInactiveDesc: 'Newly registered in range, not yet active',
    segChurnedDesc: 'Existing users with no activity in range',
    funnelLayerUsers: 'Funnel Layer Users',
    funnelCohortTip: 'Cohort of users registered in the time range, tracking subsequent conversion; click a funnel layer for the user list',
    funnelCohortRangeTip: 'Registration cohort range: {start} ~ {end}',
    dialogUserId: 'User ID',
    dialogUsername: 'Username',
    dialogName: 'Name',
    dialogUserLevel: 'Level',
    dialogPoints: 'Points',
    dialogRegisterDate: 'Registered At',
    // ---- Product Analysis ----
    nfcHourlyDist: 'Swipe Hourly Distribution',
    nfcHourlyDistTip: '24-hour swipe histogram, synced with usage trend time range',
    productRankingDesc: 'Product popularity Top10 by NFC bindings, swipe frequency or user count, synced with usage trend range',
    noUserDetailPermission: 'No permission to view user details',
    firmwareDistDesc: 'Firmware version share and OTA upgrade penetration overview, full-scope stats unaffected by time range',
    otaPenetration: 'OTA Upgrade Penetration',
    otaPenetrationTip: 'Share of devices upgraded to the latest firmware',
    otaLatest: 'Latest Version',
    otaLatestCount: 'Devices on Latest',
    otaTotalCount: 'Total Devices',
    // ---- Badge Analysis ----
    badgeSourceDist: 'Issuance by Badge Type',
    badgeSourceDistTip: 'Daily issuance stacked by badge type, synced with issuance trend time range',
    stackedByType: 'Stacked by Type',
    badgeFunnelDesc: 'User collection progress by active badge count held, full-scope stats; click a layer for the user list',
    badgeRankingDesc: 'Top10 badges by issuance within the time range, synced with issuance trend range',
    funnelBadgeUsersTip: 'Scope: users currently holding that number or more active badges',
    // ---- Points & Rights Analysis ----
    pointsAnalysis: 'Points & Rights Analysis',
    pointsAnalysisDesc: 'Points earn/spend overview and flow structure, rights exchange conversion and expiry alerts',
    pointsTotalEarn: 'Total Points Earned',
    pointsTotalSpend: 'Total Points Spent',
    pointsNetInflow: 'Net Points Inflow',
    pointsExchangeUsers: 'Exchange Users',
    pointsTrend: 'Daily Earn & Spend Trend',
    pointsTrendTip: 'Daily points earned vs spent within the time range',
    pointsEarn: 'Points Earned',
    pointsSpend: 'Points Spent',
    pointsStructure: 'Points Flow Structure',
    pointsStructureTip: 'Earn sources and spend targets distribution',
    pointsEarnSources: 'Earn Sources',
    pointsEarnSourcesTip: 'Earned points composition by source type',
    pointsSpendTargets: 'Spend Targets',
    pointsSpendTargetsTip: 'Spent points composition by target type',
    exchangeRanking: 'Rights Exchange Ranking',
    exchangeTimesUnit: 'times',
    exchangePointsCost: 'Points Cost',
    exchangeFunnel: 'Exchange Conversion Funnel',
    exchangeFunnelTip: 'Earned points → Affordable → Exchanged',
    pointsExpiryWarning: 'Points Expiry Alert',
    pointsExpiryTip: 'Points expiring in the next 90 days (by day)',
    pointsExpiryAmount: 'Expiring Points',
    pointsExpiryEmpty: 'No points expiring in the next 90 days',
    sourceNfcBind: 'NFC Swipe Earn',
    sourceManualAdd: 'Manual Add',
    sourceBatchAdd: 'Batch Grant',
    sourceExchange: 'Rights Exchange',
    sourceManualDeduct: 'Manual Deduct',
    sourceExchangeRefund: 'Exchange Refund',
    sourceOther: 'Other'
  },
  auth: {
    login: 'Login',
    register: 'Register',
    registerSubtitle: 'Create a new account',
    forgotPassword: 'Forgot Password',
    forgotPasswordSubtitle: 'Enter your phone to reset your password',
    resetPassword: 'Reset Password',
    resetPasswordSubtitle: 'Set a new password for your account',
    username: 'Username',
    phone: 'Phone',
    enterPhone: 'Enter phone number',
    phoneRequired: 'Phone number is required',
    phoneInvalid: 'Please enter a valid phone number',
    smsCaptcha: 'SMS Captcha',
    enterSmsCaptcha: 'Enter SMS captcha',
    smsCaptchaRequired: 'SMS captcha is required',
    sendSms: 'Send SMS',
    smsSentSuccess: 'SMS sent successfully',
    enterUsername: 'Enter username',
    usernamePlaceholder: 'Enter username',
    accountPlaceholder: 'Enter username / phone / email',
    accountRequired: 'Please enter your account',
    name: 'Name',
    enterName: 'Enter name',
    email: 'Email',
    enterEmail: 'Enter email',
    password: 'Password',
    enterPassword: 'Enter password',
    passwordPlaceholder: 'Enter password',
    newPassword: 'New Password',
    enterNewPassword: 'Enter new password',
    confirmPassword: 'Confirm Password',
    confirmNewPassword: 'Confirm new password',
    captcha: 'Captcha',
    enterCaptcha: 'Enter captcha',
    captchaPlaceholder: 'Enter captcha',
    refreshCaptcha: 'Refresh captcha',
    getCaptcha: 'Get Captcha',
    refreshCaptchaTooltip: 'Click to refresh captcha',
    getCaptchaError: 'Failed to get captcha',
    usernameRequired: 'Username is required',
    usernameLength: 'Username length should be 3-20 characters',
    usernamePattern: 'Username can only contain letters, numbers, underscores and hyphens',
    nameRequired: 'Name is required',
    nameLength: 'Name length should be 2-50 characters',
    emailRequired: 'Email is required',
    emailPattern: 'Please enter a valid email address',
    passwordRequired: 'Password is required',
    newPasswordRequired: 'New password is required',
    passwordLength: 'Password length should be 6-20 characters',
    confirmPasswordRequired: 'Confirm password is required',
    passwordNotMatch: 'Passwords do not match',
    captchaRequired: 'Captcha is required',
    backToLogin: 'Back to Login',
    haveAccount: 'Already have an account?',
    registerSuccess: 'Registration successful!',
    registerError: 'Registration failed. Please try again.',
    forgotPasswordSuccess: 'Password reset email sent successfully!',
    forgotPasswordError: 'Failed to send reset email. Please try again.',
    resetEmailSent: 'Password reset email sent successfully!',
    resetPasswordSuccess: 'Password reset successful!',
    resetPasswordError: 'Password reset failed. Please try again.',
    invalidResetLink: 'Invalid or expired reset link.',
    invalidResetToken: 'Invalid or expired reset token.',
    validateTokenError: 'Failed to validate reset token.',
    rememberMe: 'Remember me',
    loginButton: 'Login',
    orLoginWith: 'Or login with',
    loginTitle: 'Welcome to login',
    loginSubtitle: 'Please enter your account information',
    captchaLength: 'Captcha length should be 5 characters',
    usernameInvalid: 'Username format is invalid',
    // Specific login error messages
    loginFailed: 'Login failed',
    accountPasswordError: 'Incorrect username or password',
    passwordLengthError: 'Password length error',
    passwordWeakError: 'Password strength insufficient',
    captchaError: 'Captcha error',
    accountDisabled: 'Account is disabled',
    encryptFailed: 'Encryption failed, please try again',
    loginSuccess: 'Login successful',
    networkError: 'Network connection error',
    serverError: 'Server error',
    unknownError: 'Unknown error'
  },
  error: {
    pageNotFound: 'Sorry, the page you visited does not exist',
    backHome: 'Back to Home'
  },
  icons: {
    menu: 'Menu',
    mobile: 'Mobile',
    connection: 'Connection',
    folder: 'Folder',
    document: 'Document',
    location: 'Location',
    time: 'Time',
    setting: 'Setting',
    star: 'Star',
    picture: 'Picture',
    camera: 'Camera',
    headset: 'Headset',
    mic: 'Mic',
    phone: 'Phone',
    printer: 'Printer',
    refresh: 'Refresh',
    back: 'Back',
    forward: 'Forward',
    left: 'Left',
    right: 'Right',
    down: 'Down',
    up: 'Up',
    dLeft: 'Double Left',
    dRight: 'Double Right',
    position: 'Position',
    upload: 'Upload',
    download: 'Download',
    loading: 'Loading',
    view: 'View',
    scale: 'Scale',
    sort: 'Sort',
    sortUp: 'Sort Up',
    sortDown: 'Sort Down',
    finished: 'Finished',
    more: 'More'
  },
  userManagement: {
    userList: 'User List',
    userListTips: 'Manage system user information with multi-dimensional queries and fine-grained permission configuration',
    userGroupListTips: 'Define user group architecture for unified permission distribution and group-based management',
    createUser: 'Create User',
    userDetail: 'User Detail',
    editUser: 'Edit User',
    userId: 'User ID',
    enterUsername: 'Enter user ID',
    usernameRequired: 'User ID is required',
    usernameLength: 'User ID length should be 3-64 characters',
    usernamePattern: 'User ID can only contain letters, numbers, underscores and hyphens',
    userIdRequired: 'User ID is required',
    userIdLength: 'User ID length should be 3-32 characters',
    userIdPattern: 'User ID can only contain letters, numbers, underscores and hyphens',
    name: 'Name',
    inputName: 'Enter name',
    nameRequired: 'Name is required',
    nameLength: 'Name length should be 2-50 characters',
    email: 'Email',
    inputEmail: 'Enter email',
    enterEmail: 'Enter email',
    emailRequired: 'Email is required',
    emailPattern: 'Please enter a valid email address',
    phone: 'Phone',
    enterPhone: 'Enter phone',
    phoneRequired: 'Phone is required',
    phoneInvalid: 'Please enter a valid phone number',
    password: 'Password',
    inputPassword: 'Enter password',
    enterPassword: 'Enter password',
    passwordRequired: 'Password is required',
    passwordLength: 'Password length should be 6-32 characters',
    confirmPassword: 'Confirm Password',
    confirmPasswordRequired: 'Confirm password is required',
    passwordNotMatch: 'Passwords do not match',
    newPassword: 'New Password',
    inputNewPassword: 'Enter new password',
    confirmNewPassword: 'Confirm new password',
    role: 'Role',
    selectRole: 'Select role',
    roleRequired: 'Role is required',
    groupRequired: 'Group is required',
    admin: 'Admin',
    user: 'User',
    userId: 'User ID',
    deviceCount: 'Device Count',
    peripheralCount: 'NFC Peripherals',
    ip: 'IP Address',
    running: 'Running',
    stopped: 'Stopped',
    status: 'Status',
    remove: 'Remove',
    active: 'Active',
    inactive: 'Inactive',
    inUse: 'In Use',
    cancelled: 'Cancelled',
    frozen: 'Frozen',
    freeze: 'Freeze',
    unfreeze: 'Unfreeze',
    cancelAccount: 'Deactivate',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    unknown: 'Secret',
    userLevel: 'User Level',
    userLevelNormal: 'Normal User',
    userLevelVIP: 'VIP Member',
    userLevelSVIP: 'SVIP Member',
    roleSuperAdmin: 'Super Admin',
    roleAdmin: 'Admin',
    roleUser: 'Normal User',
    roleUnknown: 'Unknown Role',
    accountBalance: 'Balance',
    points: 'Points',
    serviceExpiryDate: 'Expiry Date',
    selectExpiryDate: 'Select expiry date',
    month: 'Months',
    customMonth: 'Custom Months',
    quickAdd: 'Quick Add',
    addMonth: 'Add {count} Months',
    selectUserLevel: 'Select user level',
    userLevelRequired: 'User level is required',
    accountBalanceRequired: 'Account balance is required',
    svip: 'SVIP',
    vip: 'VIP',
    normal: 'Normal',
    basicInfo: 'Basic Information',
    userBasicInfo: 'User Basic Information',
    activitySummary: 'Activity Summary',
    dataOverview: 'Data Overview',
    memorialCount: 'Memorials',
    noGroups: 'This user has not joined any groups yet',
    noLogs: 'No operation logs available',
    passwordSettings: 'Password Settings',
    userNotFound: 'User not found',
    searchDevice: 'Search Device',
    deviceName: 'Device Name',
    deviceType: 'Model',
    bindTime: 'Bind Time',
    confirmUnbind: 'Are you sure you want to unbind device "{name}"?',
    oldPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    oldPasswordRequired: 'Current password is required',
    newPasswordRequired: 'New password is required',
    confirmPasswordRequired: 'Confirm password is required',
    changePassword: 'Change Password',
    changePasswordSuccess: 'Password changed successfully',
    changePasswordError: 'Failed to change password',
    loadingDevices: 'Loading devices...',
    fetchDevicesError: 'Failed to load devices',
    noDevices: 'No devices bound to this user',
    createSuccess: 'User created successfully',
    createError: 'Failed to create user',
    updateSuccess: 'User updated successfully',
    updateError: 'Failed to update user',
    deleteConfirm: 'Are you sure you want to delete user {username}?',
    deleteSuccess: 'User deleted successfully',
    deleteError: 'Failed to delete user',
    enableSuccess: 'User enabled successfully',
    disableSuccess: 'User disabled successfully',
    statusChangeError: 'Failed to change status',
    fetchRoleError: 'Failed to fetch roles',
    noRolePermission: 'No permission to fetch roles, role will remain unchanged',
    noPermissionView: 'No permission to view this user information',
    batchDeleteConfirm: 'Are you sure you want to delete {count} selected users?',
    batchDeleteSuccess: 'Batch delete successful',
    batchDeleteError: 'Failed to delete selected users',
    batchEnableSuccess: 'Batch enable successful',
    batchDisableSuccess: 'Batch disable successful',
    batchStatusChangeError: 'Failed to change status of selected users',
    cannotDeleteAdmin: 'Cannot delete admin account',
    cannotDisableAdmin: 'Cannot disable admin account',
    cannotChangeCancelledStatus: 'Cannot change status of cancelled user',
    searchUsername: 'Search username',
    searchEmail: 'Search email',
    filterByGroup: 'Filter by group',
    filterByStatus: 'Filter by status',
    userAgents: 'Related Agents',
    searchAgent: 'Search Agent Name/Code',
    noAgents: 'No agents related to this user',
    selectedCount: '{count} users selected',
    enableSelected: 'Enable selected users',
    disableSelected: 'Disable selected users',
    deleteSelected: 'Delete selected users',
    searchUsernameOrEmail: 'Search username or email',
    searchGroupName: 'Search group name',
    enterUsernameOrEmail: 'Enter username or email',
    groupList: 'User Group List',
    groupDetail: 'User Group Detail',
    createGroup: 'Create Group',
    editGroup: 'Edit Group',
    groupName: 'Group Name',
    enterGroupName: 'Enter group name',
    groupNameRequired: 'Group name is required',
    groupNameLength: 'Group name length should be 2-64 characters',
    description: 'Description',
    enterDescription: 'Enter description',
    memberCount: 'Member Count',
    groupUserRequired: 'Please select at least one user',
    groupCreateSuccess: 'Group created successfully',
    groupCreateError: 'Failed to create group',
    groupUpdateSuccess: 'Group updated successfully',
    groupUpdateError: 'Failed to update group',
    groupDeleteSuccess: 'Group deleted successfully',
    groupDeleteError: 'Failed to delete group',
    groupMembers: 'Group Members',
    addUsers: 'Add Users',
    addUsersToGroup: 'Add Users to Group',
    addSelected: 'Add Selected Users',
    addUsersSuccess: 'Users added successfully',
    addUsersError: 'Failed to add users',
    removeUserFromGroupConfirm: 'Are you sure you want to remove user {username} from the group?',
    removeUserSuccess: 'User removed successfully',
    removeUserError: 'Failed to remove user',
    batchRemoveUsersConfirm: 'Are you sure you want to remove {count} selected users?',
    removeSelected: 'Remove selected users',
    batchRemoveUsersSuccess: 'Batch remove successful',
    batchRemoveUsersError: 'Failed to remove selected users',
    updateUserStatusSuccess: 'User status updated successfully',
    updateUserStatusError: 'Failed to update user status',
    pleaseSelectUsers: 'Please select users to add',
    selectGroup: 'Select Group',
    enterGroupDescription: 'Please enter group description',
    assignedUsers: 'Assigned Users',
    selectUsersToSelect: 'Please select users to assign',
    userSelectionHint: 'You can search by username or email for selection',
    neverLogin: 'Never logged in',
    users: 'Users',
    fetchError: 'Failed to fetch user list',
    fetchErrorDetailed: 'Unable to fetch user list, internal server error (500)',
    fetchGroupError: 'Failed to fetch user groups',
    fetchGroupErrorDetailed: 'Unable to fetch user groups, internal server error (500)',
    bindDevicesSuccess: 'Devices bound successfully',
    bindDevicesError: 'Failed to bind devices',
    bindSelectedDevices: 'Bind Selected Devices',
    operationType: 'Operation Type',
    removeFromGroup: 'Remove from Group',
    assignUsersToGroupDesc: 'Are you sure you want to assign the selected {count} users to a group?',
    selectUserGroup: 'Please select user group',
    noDescription: 'No Description',
    avatar: 'Avatar',
    uploadAvatar: 'Upload Avatar',
    cropAvatar: 'Crop Avatar',
    selectDefaultAvatar: 'Select Default Avatar',
    selectImageTip: 'Please select an image file',
    avatarSizeTip: 'Please upload an image and crop it to 128*128 square',
    uploadError: 'Avatar upload failed'
  },
  dictManagement: {
    pageTitle: 'Dictionary Management',
    searchPlaceholder: 'Enter dictionary type or name to search',
    search: 'Search',
    dictTypeName: 'Dict Type Name',
    dictTypeCode: 'Dict Type Code',
    operation: 'Operation',
    edit: 'Edit',
    dictLabel: 'Dict Label',
    dictValue: 'Dict Value',
    sort: 'Sort',
    delete: 'Delete',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    addDictType: 'Add Dict Type',
    batchDeleteDictType: 'Batch Delete Dict Type',
    addDictData: 'Add Dict Data',
    batchDeleteDictData: 'Batch Delete Dict Data',
    itemsPerPage: '{items} items/page',
    firstPage: 'First',
    prevPage: 'Prev',
    nextPage: 'Next',
    totalRecords: 'Total {total} records',
    editDictType: 'Edit Dict Type',
    editDictData: 'Edit Dict Data',
    saveSuccess: 'Saved successfully',
    deleteSuccess: 'Deleted successfully',
    selectDictTypeToDelete: 'Please select dict types to delete',
    confirmDeleteDictType: 'Are you sure you want to delete selected dict types?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    selectDictTypeFirst: 'Please select a dict type first',
    confirmDeleteDictData: 'Are you sure you want to delete this dict data?',
    selectDictDataToDelete: 'Please select dict data to delete',
    confirmBatchDeleteDictData: 'Are you sure you want to delete {count} selected dict data?',
    getDictDataFailed: 'Failed to get dict data',
    dictTypeRequired: 'Dict type is required',
    dictNameRequired: 'Dict name is required',
    dictLabelRequired: 'Dict label is required',
    dictValueRequired: 'Dict value is required'
  },
  otaManagement: {
    firmwareManagement: 'Firmware Management',
    searchPlaceholder: 'Enter firmware name to search',
    search: 'Search',
    firmwareName: 'Firmware Name',
    firmwareType: 'Firmware Type',
    version: 'Version',
    fileSize: 'File Size',
    remark: 'Remark',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    action: 'Action',
    download: 'Download',
    edit: 'Edit',
    delete: 'Delete',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    addNew: 'Add Firmware',
    addFirmware: 'Add Firmware',
    editFirmware: 'Edit Firmware',
    itemsPerPage: '{items} items/page',
    firstPage: 'First',
    prevPage: 'Prev',
    nextPage: 'Next',
    totalRecords: 'Total {total} records',
    selectFirmwareFirst: 'Please select firmware to delete first',
    confirmBatchDelete: 'Are you sure you want to delete {paramCount} selected firmwares?',
    operationCancelled: 'Operation cancelled',
    operationClosed: 'Operation closed',
    batchDeleteSuccess: 'Deleted {paramCount} firmwares successfully',
    deleteFailed: 'Delete failed, please try again',
    incompleteFirmwareInfo: 'Incomplete firmware information',
    getDownloadUrlFailed: 'Failed to get download URL',
    getFirmwareTypesFailed: 'Failed to get firmware types',
    updateSuccess: 'Updated successfully',
    updateFailed: 'Update failed',
    addSuccess: 'Added successfully',
    addFailed: 'Add failed',
    fetchFirmwareListFailed: 'Failed to fetch firmware list',
    invalidFirmwareId: 'Invalid firmware ID',
    downloadTitle: 'Firmware Download',
    remainingTime: 'Remaining Time',
    downloading: 'Downloading...',
    paused: 'Paused',
    completed: 'Completed',
    failed: 'Failed'
  },
  firmwareDialog: {
    firmwareName: 'Firmware Name',
    firmwareNamePlaceholder: 'Enter firmware name (Board + Version)',
    firmwareType: 'Firmware Type',
    firmwareTypePlaceholder: 'Select firmware type',
    version: 'Version',
    versionPlaceholder: 'Enter version (x.x.x format)',
    firmwareFile: 'Firmware File',
    clickUpload: 'Click to Upload',
    uploadTip: 'Only .bin/.apk/.wav files, max 100MB',
    uploadHint: 'Tip: Please upload the agent.bin before merging, not the merged-binary.bin',
    remark: 'Remark',
    remarkPlaceholder: 'Enter remark information',
    requiredFirmwareName: 'Firmware name is required',
    requiredFirmwareType: 'Firmware type is required',
    requiredVersion: 'Version is required',
    versionFormatError: 'Invalid version format, use x.x.x',
    requiredFirmwareFile: 'Firmware file is required',
    invalidFileType: 'Only .bin/.apk/.wav files are allowed!',
    invalidFileSize: 'File size cannot exceed 100MB!',
    uploadSuccess: 'Upload successful',
    uploadFailed: 'Upload failed'
  },
  providerManagement: {
    pageTitle: 'Provider Management',
    categoryFilter: 'Category Filter',
    searchPlaceholder: 'Enter provider name to search',
    category: 'Category',
    providerCode: 'Provider Code',
    fieldConfig: 'Field Config',
    selectToDelete: 'Please select providers to delete first',
    confirmDelete: 'Are you sure you want to delete {count} selected providers?',
    viewFields: 'View Fields',
    all: 'All',
    modelType: {
      ASR: 'ASR',
      TTS: 'TTS',
      LLM: 'LLM',
      VLLM: 'VLLM',
      INTENT: 'Intent',
      MEMORY: 'Memory',
      VAD: 'VAD',
      PLUGIN: 'Plugin',
      RAG: 'RAG'
    }
  },
  providerDialog: {
    category: 'Category',
    selectCategory: 'Select category',
    code: 'Code',
    inputCode: 'Enter provider code',
    name: 'Name',
    inputName: 'Enter provider name',
    sort: 'Sort',
    fieldConfig: 'Field Config',
    add: 'Add Field',
    deselectAll: 'Deselect All',
    selectAll: 'Select All',
    batchDelete: 'Batch Delete',
    fieldKey: 'Field Key',
    fieldLabel: 'Field Label',
    fieldType: 'Field Type',
    type: 'Type',
    stringType: 'String',
    numberType: 'Number',
    booleanType: 'Boolean',
    dictType: 'Dictionary',
    arrayType: 'Semicolon-separated list',
    ragType: 'RAG',
    defaultValue: 'Default Value',
    inputDefaultValue: 'Enter default value',
    operation: 'Operation',
    edit: 'Edit',
    complete: 'Complete',
    delete: 'Delete',
    save: 'Save',
    requiredCategory: 'Category is required',
    requiredCode: 'Provider code is required',
    requiredName: 'Provider name is required',
    completeFieldEdit: 'Please complete current field editing',
    confirmDeleteField: 'Are you sure you want to delete this field?',
    selectFieldsToDelete: 'Please select fields to delete',
    confirmBatchDeleteFields: 'Are you sure you want to delete {count} selected fields?',
    batchDeleteFieldsSuccess: 'Deleted {count} fields successfully'
  },
  paramManagement: {
    pageTitle: 'Parameter Management',
    searchPlaceholder: 'Enter parameter code or remark to search',
    search: 'Search',
    paramCode: 'Param Code',
    paramValue: 'Param Value',
    valueType: 'Value Type',
    paramType: 'Param Type',
    systemParam: 'System Param',
    nonSystemParam: 'Normal Param',
    remark: 'Remark',
    operation: 'Operation',
    hide: 'Hide',
    view: 'View',
    deselectAll: 'Deselect All',
    selectAll: 'Select All',
    add: 'Add',
    delete: 'Delete',
    edit: 'Edit',
    itemsPerPage: 'items/page',
    firstPage: 'First',
    prevPage: 'Prev',
    nextPage: 'Next',
    totalRecords: 'Total {total} records',
    addParam: 'Add Parameter',
    editParam: 'Edit Parameter',
    getParamsListFailed: 'Failed to get parameter list',
    selectParamsFirst: 'Please select parameters to delete first',
    confirmBatchDelete: 'Are you sure you want to delete {paramCount} selected parameters?',
    invalidParamId: 'Invalid parameter ID detected',
    batchDeleteSuccess: 'Deleted {paramCount} parameters successfully',
    deleteFailed: 'Delete failed, please try again',
    operationCancelled: 'Delete operation cancelled',
    operationClosed: 'Operation closed',
    updateSuccess: 'Updated successfully',
    addSuccess: 'Added successfully',
    updateFailed: 'Update failed',
    addFailed: 'Add failed',
    paramCodeRequired: 'Param code is required',
    paramValueRequired: 'Param value is required',
    valueTypeRequired: 'Please select value type'
  },
  resourceManagement: {
    dashboard: 'Overview & Monitoring',
    resourceDashboardTips: 'Real-time monitoring of system resource status, model call distribution, and core metrics',
    resourceQuota: 'Resource Quota',
    resourceQuotaTips: 'Monitor and adjust user resource quotas, manage account balances and consumption limits',
    quotaDetail: 'Quota Detail',
    totalQuota: 'Total Quota',
    basicInfo: 'Basic Info',
    usageDetails: 'Usage Details',
    modelList: 'Model List',
    modelListTips: 'Manage all supported AI models, configure provider parameters and operational status',
    modelType: 'Model Type',
    modelId: 'Model ID',
    supplier: 'Supplier',
    docLink: 'Doc Link',
    remark: 'Remark',
    callInfo: 'Call Info',
    modelInfo: 'Model Info',
    selectSupplier: 'Please select supplier',
    jsonFormatError: 'JSON format error, must be an object',
    resourceUsage: 'Resource Usage',
    cpuUsage: 'CPU Usage',
    memoryUsage: 'Memory Usage',
    storageUsage: 'Storage Usage',
    quotaExceeded: 'Quota Exceeded',
    usageTrend: 'Usage Trend',
    generateReport: 'Generate Report',
    reportGenerated: 'Report generated successfully',
    totalResources: 'Total Resources',
    modelTotalResources: 'Total Provider Resources',
    userTotalResources: 'Total User Allocation',
    usedResources: 'Total Consumed',
    userAvailableResources: 'User Remaining',
    modelAvailableResources: 'Provider Remaining',
    normalOperationResources: 'Normal Operation Resources',
    resourceUsageWarning: 'Resource Usage Warning',
    resourceUsageAbnormal: 'Resource Usage Abnormal',
    computeResources: 'Compute Resources',
    storageResources: 'Storage Resources',
    networkResources: 'Network Resources',
    memoryResources: 'Memory Resources',
    timeRange: 'Time Range',
    chartType: 'Chart Type',
    lineChart: 'Line Chart',
    barChart: 'Bar Chart',
    resourceAlerts: 'Resource Alerts',
    alertType: 'Alert Type',
    alertTitle: 'Alert Title',
    alertDescription: 'Alert Description',
    alertLevel: 'Alert Level',
    info: 'Info',
    warning: 'Warning',
    error: 'Error',
    critical: 'Critical',
    concurrencyAlert: 'Concurrency Alert',
    balanceAlert: 'Balance Alert',
    anomalyAlert: 'Anomaly Alert',
    usageAlert: 'Usage Alert',
    modelQuotaAlert: 'Model Quota Alert',
    userQuotaAlert: 'User Quota Alert',
    errorRateAlert: 'Error Rate Alert',
    checkNow: 'Check Now',
    alertDetail: 'Alert Detail',
    alertTitle: 'Alert Title',
    occurTime: 'Trigger Time',
    alertDescription: 'Alert Content',
    modelName: 'Related Model',
    viewModelDetail: 'View Model Detail',
    userName: 'Related User',
    viewUserInfo: 'View User Info',
    markAsResolved: 'Mark as Resolved',
    alertCheckSuccess: 'Resource alert check completed',
    alertCheckFailed: 'Manual trigger alert check failed',
    confirmClearAlerts: 'Are you sure you want to clear all processed alerts?',
    confirmResolveAlert: 'Are you sure you want to mark this alert as resolved?',
    statusUnprocessed: 'Unprocessed',
    statusIgnored: 'Ignored',
    statusResolved: 'Resolved',
    enterProcessRemark: 'Please enter processing remark',
    remarkPlaceholder: 'Processing remark',
    alertProcessed: 'Alert processed successfully',
    confirmIgnoreAlert: 'Are you sure you want to ignore this alert?',
    alertIgnored: 'Alert ignored successfully',
    resourceId: 'Resource ID',
    resourceName: 'Resource Name',
    currentValue: 'Current Value',
    threshold: 'Threshold',
    changeRate: 'Change Rate',
    occurTime: 'Occur Time',
    unprocessed: 'Unprocessed',
    processed: 'Processed',
    utilizationTooHigh: 'High Utilization',
    suddenIncreaseAbnormal: 'Sudden Increase Abnormal',
    normalRunningResources: 'Normal Running Resources',
    fetchOverviewFailed: 'Failed to fetch resource overview',
    fetchUsageFailed: 'Failed to fetch resource usage',
    fetchAlertListFailed: 'Failed to fetch alert list',
    confirmProcessAlert: 'Are you sure you want to process this alert?',
    userManualProcess: 'User manual process',
    handleAlertFailed: 'Failed to process alert',
    ignoreAlertFailed: 'Failed to ignore alert',
    realtimeUpdatesEnabled: 'Real-time updates enabled',
    realtimeUpdatesDisabled: 'Real-time updates disabled',
    alertProcessed: 'Alert processed successfully',
    utilization: 'Utilization',
    abnormal: 'Abnormal',
    average: 'Average',
    resourceUsageTrend: 'Resource Usage Trend',
    alertDetail: 'Alert Detail',
    fetchAlertDetailFailed: 'Failed to fetch alert detail',
    realtimeOn: 'Realtime Updating',
    realtimeOff: 'Realtime Updates Off',
    enableRealtimeUpdates: 'Enable realtime data updates',
    disableRealtimeUpdates: 'Disable realtime data updates',
    realtimeUpdatesEnabled: 'Realtime updates enabled',
    realtimeUpdatesDisabled: 'Realtime updates disabled',
    lastUpdateTime: 'Last Update Time',
    availableResources: 'Total Remaining Quota',
    utilizationRate: 'Utilization Rate',
    quotaDistribution: 'Quota Distribution',
    modelUsageRatio: 'Model Usage Distribution',
    callCount: 'Call Count',
    tokenConsumption: 'Token Consumption',
    granularity: 'Granularity',
    hour: 'Hour',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    dataLabel: 'Data Label',
    viewQuota: 'View Quota',
    resourceUsageRanking: 'Resource Usage Ranking',
    modelUsageRanking: 'Model Resource Usage Ranking',
    userUsageRanking: 'User Usage Ranking',
    userName: 'User Name',
    userId: 'User ID',
    tokensConsumed: 'Tokens Consumed',
    rank: 'Rank',
    usageAmount: 'Usage Amount',
    noUsageData: 'No usage data',
    businessType: 'Business Type',
    bizChat: 'Chat',
    bizSTT: 'STT',
    bizTTS: 'TTS',
    bizVAD: 'VAD',
    bizOCR: 'OCR',
    allocateQuota: 'Allocate Resource Quota',
    editQuota: 'Edit Quota',
    quotaList: 'Quota List',
    quotaValue: 'Quota Value',
    usedValue: 'Used',
    remainingValue: 'Remaining',
    limitLine: 'Limit Line',
    warningLine: 'Warning Line',
    viewUsage: 'View Usage',
    resourceType: 'Resource Type',
    token: 'Token',
    resourceTypePlaceholder: 'Please select resource type',
    quotaValuePlaceholder: 'Please enter quota value',
    effectiveTimePlaceholder: 'Select effective time',
    expiryTimePlaceholder: 'Select expiry time',
    remarkPlaceholder: 'Please enter remark',
    userPlaceholder: 'Please select user',
    quotaUpdateSuccess: 'Quota updated successfully',
    quotaAllocateSuccess: 'Quota allocated successfully',
    quotaUpdateFailed: 'Quota update failed',
    quotaAllocateFailed: 'Quota allocation failed',
    quotaPolicy: 'Quota Policy',
    quotaPolicyTips: 'Define resource quota issuance and reset rules for different user levels',
    policyName: 'Policy Name',
    userLevel: 'User Level',
    modelType: 'Model Type',
    allocatedTokens: 'Allocated Tokens',
    isUnlimited: 'Unlimited Quota',
    unlimited: 'Unlimited',
    allowedModels: 'Allowed Models',
    allModels: 'All Models (*)',
    selectModelsPlaceholder: 'Select models (empty for no permission)',
    monthlyReset: 'Monthly Reset',
    quotaLogs: 'Resource Audit Logs',
    quotaLogsTips: 'View resource quota change records, audit flows, and system alert logs',
    alertLog: 'Resource Alert Records',
    operationLog: 'Quota Change Logs',
    transactionRecord: 'Balance Transaction Flow',
    usageDetails: 'Resource Usage Details',
    businessType: 'Business Type',
    amount: 'Change Amount',
    balance: 'Current Balance',
    operator: 'Operator',
    targetUser: 'Target User',
    changeType: 'Change Type',
    currentQuota: 'New Total Quota',
    initQuota: 'Initial Quota',
    manualAdjust: 'Manual Adjust',
    manualBatchAdjust: 'Batch Adjust',
    autoReset: 'Auto Reset',
    policyApply: 'Policy Apply',
    tokenConsume: 'Token Consumption',
    monthlyResetAction: 'Cycle Reset',
    statusChange: 'Status Change',
    deleteQuotaConfirm: 'Are you sure you want to delete the quota for {type} resource?',
    fetchQuotaListFailed: 'Failed to fetch quota list',
    quotaValueMin: 'Quota value must be greater than 0',
    modelName: 'Model Name',
    adjustSetting: 'Adjust Settings',
    filterCondition: 'Filter Conditions',
    selectGroups: 'Select Groups',
    allUsers: 'All Users',
    regTimeRange: 'Registration Time Range',
    executeAdjust: 'Execute Adjustment',
    previewFailed: 'Preview failed',
    noPreviewConfirm: 'Preview not performed. Execute adjustment directly?',
    noPreviewModifyConfirm: 'Preview not performed. Execute modification directly?',
    executeDirectly: 'Execute directly',
    previewFirst: 'Preview first',
    batchAdjustSuccess: 'Batch adjustment successful',
    batchEditSuccess: 'Batch modification successful',
    executeFailed: 'Execution failed',
    resetCycle: 'Reset Cycle',
    tokenAllocation: 'Token Allocation',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly',
    none: 'None',
    modelPlaceholder: 'Please select model',
    resetCyclePlaceholder: 'Please select reset cycle',
    effectiveTime: 'Effective Time',
    expiryTime: 'Expiry Time',
    noAlerts: 'No alerts',
    noResourceAlerts: 'No resource alerts',
    noUsageData: 'No usage data',
    provider: 'Provider',
    provideCode: 'Provider Code',
    isDefault: 'Is Default',
    voiceList: 'Voice List',
    addModel: 'Add Model',
    editModel: 'Edit Model',
    deleteModel: 'Delete Model',
    modelConfig: 'Model Config',
    providerConfig: 'Provider Config',
    llmModel: 'LLM Model',
    ttsModel: 'TTS Model',
    asrModel: 'ASR Model',
    imgGenModel: 'Image Generation',
    searchModel: 'Search model name',
    confirmDeleteModel: 'Are you sure you want to delete this model configuration?',
    deleteModelSuccess: 'Model deleted successfully',
    addModelSuccess: 'Model added successfully',
    updateModelSuccess: 'Model updated successfully',
    alertLog: 'Alert Log',
    alertType: 'Alert Type',
    alertLevel: 'Alert Level',
    alertTitle: 'Alert Title',
    alertContent: 'Alert Content',
    alertStatus: 'Alert Status',
    unprocessed: 'Unprocessed',
    ignored: 'Ignored',
    resolved: 'Resolved',
    resolveTime: 'Resolve Time',
    remark: 'Remark',
    confirmIgnore: 'Are you sure you want to ignore this alert?',
    confirmResolve: 'Resolve Remark',
    resolveSuccess: 'Resolved successfully',
    ignoreSuccess: 'Ignored successfully',
    modelQuota: 'Model Quota',
    userQuota: 'User Quota',
    errorRate: 'Error Rate',
    warning: 'Warning',
    critical: 'Critical',
    unsupportedExport: 'Current tab does not support export',
    exportFailed: 'Export failed',
    threshold: 'Alert Threshold',
    enterThreshold: 'Please enter alert threshold (0-100)',
    sortOrder: 'Sort Order',
    sortOrderPlaceholder: 'Enter sort order (smaller numbers come first)',
    basicConfig: 'Basic Config',
    apiConfig: 'API Config',
    selectSupplier: 'Please select provider',
    jsonFormatError: 'JSON format error, must be an object',
    fetchModelListFailed: 'Failed to fetch model list',
    fetchProvidersFailed: 'Failed to fetch providers',
    fetchVoicesFailed: 'Failed to fetch voices',
    resourceReportTips: 'Multi-dimensional analysis of resource consumption trends, generating visual usage statistics reports',
    generateReport: 'Generate Report',
    vsLastPeriod: 'vs Last Period',
    distributionDetails: 'Consumption Distribution Details',
    // Report related
    reportConfiguration: 'Report Configuration',
    reportType: 'Report Type',
    usageSummary: 'Usage Summary',
    trendAnalysis: 'Trend Analysis',
    costAnalysis: 'Cost Analysis',
    forecastReport: 'Forecast Report',
    resourceTypes: 'Resource Types',
    previewReport: 'Preview Report',
    reportPreview: 'Report Preview',
    resourceUsageReport: 'Resource Usage Report',
    generateTime: 'Generation Time',
    overview: 'Overview',
    totalUsage: 'Total Usage',
    averageUsage: 'Average Usage',
    peakUsage: 'Peak Usage',
    totalCost: 'Total Cost',
    usageTrends: 'Usage Trends',
    resourceDistribution: 'Resource Distribution',
    usage: 'Usage',
    percentage: 'Percentage',
    cost: 'Cost',
    alertsAndEvents: 'Alerts and Events',
    impact: 'Impact',
    highImpact: 'High Impact',
    mediumImpact: 'Medium Impact',
    lowImpact: 'Low Impact',
    recommendations: 'Recommendations',
    warning: 'Warning',
    error: 'Error',
    info: 'Info',
    optimization: 'Optimization',
    // Resource Alert related
    concurrencyAlert: 'Concurrency Alert',
    balanceAlert: 'Balance Alert',
    anomalyAlert: 'Anomaly Alert',
    usageAlert: 'Usage Alert',
    errorRateAlert: 'Error Rate Alert',
    statusUnprocessed: 'Unprocessed',
    statusIgnored: 'Ignored',
    statusResolved: 'Resolved',
    alertCheckSuccess: 'Resource alert check completed',
    alertCheckFailed: 'Manual alert check failed',
    confirmIgnoreAlert: 'Are you sure you want to ignore this alert?',
    alertIgnored: 'Alert ignored',
    enterProcessRemark: 'Please enter process remark',
    remarkPlaceholder: 'Process remark',
    alertProcessed: 'Alert processed',
    checkNow: 'Check Now',
    fetchAlertListFailed: 'Failed to fetch alert list',
    viewModelDetail: 'View Model Details',
    viewUserInfo: 'View User Information',
    confirmResolveAlert: 'Are you sure you want to mark this alert as resolved?',
    markAsResolved: 'Mark as Resolved',
    confirmClearAlerts: 'Are you sure you want to clear all resolved alerts?',
    critical: 'Critical',
    ASR_AliyunASR: 'Aliyun ASR',
    ASR_AliyunStreamASR: 'Aliyun Stream ASR',
    ASR_DoubaoASR: 'Doubao ASR',
    modelProvider: 'Provider Management',
    modelProviderTips: 'Configure and manage model providers from different vendors, integrating multiple AI capabilities'
  },
  roleManagement: {
    roleManagement: 'Role Management',
    rolePermissionManagement: 'Role & Permission Management',
    userRoleListTips: 'Configure role permission models with function and button-level authorization for system security',
    createRole: 'Create Role',
    viewRole: 'View Role',
    viewRoleList: 'View Role List & Details',
    createRolePermission: 'Create Role & Assign Permissions',
    editRole: 'Edit Role',
    modifyRolePermission: 'Modify Role & Permissions',
    deleteRole: 'Delete Role',
    deleteRolePermission: 'Delete Role & Related Permissions',
    roleList: 'Role List',
    permissionConfiguration: 'Permission Configuration',
    savePermissions: 'Save Permissions',
    pageAccessPermissions: 'Page Access Permissions',
    operationButtonPermissions: 'Operation Button Permissions',
    roleStatus: 'Role Status',
    pleaseSelectRoleForConfig: 'Please select a role to configure permissions',
    createRoleDialogTitle: 'Create Role',
    editRoleDialogTitle: 'Edit Role',
    roleName: 'Role Name',
    enterRoleName: 'Please enter role name',
    roleNameRequired: 'Role name is required',
    roleDescription: 'Role Description',
    enterRoleDescription: 'Please enter role description',
    roleDescriptionRequired: 'Role description is required',
    deleteRoleConfirm: 'Are you sure you want to delete role "{roleName}"?',
    deleteNodeConfirm: 'Are you sure you want to delete node "{name}"?',
    deleteRoleSuccess: 'Delete successful',
    createRoleSuccess: 'Create successful',
    updateRoleSuccess: 'Update successful',
    savePermissionsSuccess: 'Permissions saved successfully',
    savePermissionsError: 'Failed to save permissions',
    superAdminAllPermissions: 'Super admin has all permissions and cannot be modified',
    noUsersInRole: 'No users in this role',
    roleCode: 'Role Code',
    autoGenerateHint: 'Auto-generated',
    roleCodeAutoGenerateTip: 'Unique code auto-generated from role name, format: ROLE_XXX_001',
    enterRoleCode: 'Please enter role code',
    dataScope: 'Data Scope',
    dataScopeAll: 'All Data',
    dataScopeGroup: 'Group Data',
    dataScopeSelf: 'Personal Data',
    dataScopeAllTip: 'Tip: This role can view data from all users in the system.',
    dataScopeGroupTip: 'Tip: This role can view data from all members in the same group.',
    dataScopeSelfTip: 'Tip: This role can only view its own data.',
    pagesSelected: 'pages',
    buttonsSelected: 'buttons',
    selectMenuForButtons: 'Please select a page menu from the tree above to configure its operation buttons.',
    noButtonsForMenu: 'This page menu has no associated operation buttons.',
    menuNotCheckedTip: 'The current page is not checked. Please check the page access permission first before configuring button permissions.',
    orphanButtonsWarning: 'The parent pages of the following button permissions are not selected and have been automatically removed: {buttons}',
    deleteRoleWithUsersConfirm: 'Role "{roleName}" still has {userCount} users. Deleting it will remove their role permissions. Are you sure?',
    permissionUpdateNotifyTitle: 'Notice',
    permissionUpdateNotifyMessage: 'Role permissions updated. Permission cache for related users has been cleared. Changes will take effect on next operation or re-login.',
    fetchRoleError: 'Failed to fetch role list',
    deleteRoleError: 'Failed to delete role',
    createRoleError: 'Failed to create role',
    updateRoleError: 'Failed to update role',
    addNode: 'Add Child',
    editNode: 'Edit Node',
    deleteNode: 'Delete Node',
    enterNodeName: 'Please enter node name',
    systemOverview: 'System overview and statistics',
    userInfoManagement: 'User information management',
    viewUserList: 'View user list and details',
    createUserAccount: 'Create new user account',
    modifyUserInfo: 'Modify user information',
    deleteUserAccount: 'Delete user account',
    deviceInfoManagement: 'Device information management',
    viewDeviceList: 'View device list and details',
    modifyDeviceInfo: 'Modify device information',
    deleteDeviceRecord: 'Delete device record',
    bindDeviceToUser: 'Bind device to user',
    resourceQuotaMonitoring: 'Resource quota and monitoring',
    viewResourceUsage: 'View resource usage',
    allocateManageQuota: 'Allocate and manage resource quotas',
    systemConfigManagement: 'System configuration and management',
    viewSystemLogs: 'View system operation logs',
    manageSystemNotifications: 'Manage system notifications',
    manageSystemConfig: 'Manage system configurations',
    createUserButton: 'Create User',
    editUserButton: 'Edit User',
    deleteUserButton: 'Delete User',
    batchOperation: 'Batch Operation',
    editDeviceButton: 'Edit Device',
    deleteDeviceButton: 'Delete Device',
    deviceUpgrade: 'Device Upgrade',
    restartDevice: 'Restart Device',
    allocateResource: 'Allocate Resource',
    adjustResource: 'Adjust Resource',
    systemBackup: 'System Backup',
    systemRestore: 'System Restore',
    allDepartments: 'All Departments',
    technologyDepartment: 'Technology Dept',
    salesDepartment: 'Sales Dept',
    administrationDepartment: 'Administration Dept',
    dashboard: 'Control Center',
    userManagement: 'User Management',
    deviceManagement: 'Device Management',
    resourceManagement: 'Resource Management',
    systemManagement: 'System Management',
    viewLogs: 'View Logs',
    notificationManagement: 'Notification Management',
    systemConfig: 'System Config'
  },
  device: {
    deviceManagement: 'Device Management',
    deviceManagementSubtitle: 'Manage all your devices',
    deviceListTips: 'Real-time monitoring of connected devices with status tracking and remote maintenance capabilities',
    deviceList: 'Device List',
    deviceDetail: 'Device Detail',
    deviceAdd: 'Add Device',
    deviceEdit: 'Edit Device',
    bindDevice: 'Bind Device',
    unbindDevice: 'Unbind Device',
    unbind: 'Unbind',
    searchPlaceholder: 'Search Device Name/MAC',
    board: 'Board/Model',
    bindTime: 'Bind Time',
    enterDeviceCode: 'Please enter device activation code',
    deviceCodePlaceholder: 'Enter activation code or ID from device',
    deviceLogs: 'Device Logs',
    getLogsFailed: 'Failed to get device logs',

    deviceName: 'Device Name',
    deviceNamePlaceholder: 'Enter device name',
    deviceCode: 'Device Code',
    deviceType: 'Device Type',
    deviceTypePlaceholder: 'Select device type',
    smartDevice: 'Smart Device',
    peripheral: 'Peripheral',
    deviceModel: 'Device Model',
    firmwareVersion: 'Firmware Version',
    macAddress: 'MAC Address',
    manufacturer: 'Manufacturer',
    onlineStatus: 'Online Status',
    bindingStatus: 'Binding Status',
    activationState: 'Activation Status',
    bindUser: 'Bound User',
    belongToUser: 'Belong to User',
    bound: 'Bound',
    unbound: 'Unbound',
    signalStrength: 'Signal Strength',
    batteryLevel: 'Battery Level',
    bindingSuccess: 'Device binding successful',
    bindingError: 'Device binding failed',
    unbindingSuccess: 'Device unbinding successful',
    unbindingError: 'Device unbinding failed',
    unbindSuccess: 'Device unbinding successful',
    unbindFailed: 'Device unbinding failed',
    lastConversation: 'Last Conversation',
    remarks: 'Remarks',
    enterRemarks: 'Enter remarks',
    unbindDeviceConfirm: 'Are you sure you want to unbind device {name}?',
    deviceInfo: 'Device Info',
    deviceBasicInfo: 'Device Basic Info',
    deviceRemark: 'Device Remark',
    autoUpdate: 'Auto Update',
    batchNo: 'Batch No',
    lifecycleStatus: 'Lifecycle Status',
    activationTime: 'Activation Time',
    lifecycleCreated: 'Created',
    lifecycleProduction: 'Production',
    lifecycleWarehouse: 'Warehouse',
    lifecycleShipped: 'Shipped',
    lifecycleActivated: 'Activated',
    lifecyclePending: 'Pending Activation',
    unactivated: 'Unactivated',
    deviceCodeFilter: 'Device Code (UUID)',
    deviceCodeFilterPlaceholder: 'Enter device code (UUID)',
    lastOnlineTime: 'Last Online Time',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    online: 'Online',
    offline: 'Offline',
    ownerName: 'Owner Name',
    deviceModelPlaceholder: 'Please select device model',
    firmwareVersionPlaceholder: 'Please enter firmware version',
    manufacturerPlaceholder: 'Please enter manufacturer',
    ownerNamePlaceholder: 'Please select owner',
    deviceRemarkPlaceholder: 'Please enter device remark',
    macAddressPlaceholder: 'Please enter device MAC address',
    macAddressRequired: 'Please enter device MAC address',
    invalidMacAddress: 'Please enter a valid MAC address',
    deviceNameRequired: 'Please enter device name',
    deviceNameLength: 'Device name length cannot exceed 50 characters',
    userIdRequired: 'Please select owner',
    macAddressFormat: 'Invalid MAC address format',
    deviceModelRequired: 'Please select device model',
    deviceCodeRequired: 'Please enter device code',
    firmwareVersionRequired: 'Please enter firmware version',
    firmwareVersionFormat: 'Invalid firmware version format',
    addConfirm: 'Are you sure you want to add this device?',
    saveConfirm: 'Are you sure you want to save the changes?',
    fetchDeviceDetailFailed: 'Failed to fetch device detail',
    fetchUserListFailed: 'Failed to fetch user list',
    updateDeviceSuccess: 'Device information updated successfully',
    updateDeviceFailed: 'Failed to update device information',
    saveSuccess: 'Save Success',
    saveFailed: 'Save Failed',
    boundAt: 'Bound At',
    createdAt: 'Created At',
    getDeviceDetailFailed: 'Failed to get device detail',
    deviceStatusMonitor: 'Device Status Monitor',
    // Device logs related
    deviceLogs: 'Device Logs',
    operationType: 'Operation Type',
    selectOperationType: 'Select Operation Type',
    operationTime: 'Operation Time',
    operatorName: 'Operator',
    enterOperatorName: 'Enter operator name',
    logId: 'Log ID',
    operationDesc: 'Operation Description',
    deviceMac: 'Device MAC',
    operationStatus: 'Status',
    confirmExportLogs: 'Are you sure you want to export device logs?',
    exportLogsSuccess: 'Logs exported successfully',
    exportLogsFailed: 'Failed to export logs',
    deviceBind: 'Device Bind',
    deviceUnbind: 'Device Unbind',
    deviceUpdate: 'Device Update',
    firmwareUpdate: 'Firmware Upgrade',
    firmwareUpgrade: 'Firmware Upgrade',
    basicInfo: 'Basic Information',
    otherInfo: 'Other Information',
    deviceRestart: 'Device Restart',
    configChange: 'Config Change',
    statusQuery: 'Status Query',
    version: 'Version',
    statusInfo: 'Status Information',
    deviceOperations: 'Device Operations',
    logType: 'Log Type',
    logDescription: 'Log Description',
    logAction: 'Action',
    logOperator: 'Operator',
    viewLogs: 'View Logs',
    recentLogs: 'Recent Logs',
    firmwareUpgradeDesc: 'Do not disconnect power or network during the upgrade process.',
    currentVersion: 'Current Version',
    targetVersion: 'Target Version',
    selectVersion: 'Please select target version',
    upgradeNotes: 'Upgrade Notes',
    upgradeNotesPlaceholder: 'Enter upgrade notes',
    allLogs: 'All Logs',
    operationLog: 'Operation Log',
    statusLog: 'Status Log',
    errorLog: 'Error Log',
    unknownLog: 'Unknown Log',
    bindDeviceDesc: 'Are you sure you want to bind device {name} to a user?',
    selectUser: 'Select User',
    bindNotes: 'Binding Notes',
    bindNotesPlaceholder: 'Enter binding notes',
    bindSuccess: 'Bound successfully',
    bindFailed: 'Binding failed',
    upgradeStart: 'Upgrade command sent',
    agentId: 'Agent ID',
    creator: 'Creator',
    updater: 'Updater',
    // Firmware upgrade page related
    deviceUpgrade: 'Device Upgrade',
    deviceUpgradeSubtitle: 'Remote management of device firmware versions with batch silent upgrade and progress tracking',
    deviceStatus: 'Device Status',
    upgrading: 'Upgrading',
    error: 'Error',
    lastUpgradeTime: 'Last Upgrade Time',
    upgradeStatus: 'Upgrade Status',
    upgradeSuccess: 'Upgrade Success',
    upgradeFailed: 'Upgrade Failed',
    upgradeInProgress: 'Upgrade in Progress',
    upgradeNotStarted: 'Not Started',
    upgradeDevice: 'Upgrade Device',
    uploadFirmware: 'Upload Firmware',
    firmwareVersionPlaceholder: 'Enter firmware version, e.g., v1.0.0',
    firmwareFile: 'Firmware File',
    dragUploadText: 'Drag file here or click to upload',
    uploadTip: 'Only bin/hex files are allowed, and size should not exceed 50MB',
    upgradeProgress: 'Upgrade Progress',
    upgradingDevice: 'Upgrading device...',
    upgradeCompletedSuccessfully: 'Device upgrade completed successfully',
    upgradeFailedMessage: 'Device upgrade failed, please check network or device status',
    upgradeLogs: 'Upgrade Logs',
    upgradeProgressLog: 'Upgrade Progress',
    upgradeCompleted: 'Upgrade Completed',
    invalidFileType: 'Invalid file type, only bin or hex files are allowed',
    fileSizeExceeded: 'File size exceeded, maximum allowed is 50MB',
    uploadLimitExceeded: 'Only one file can be uploaded at a time',
    versionRequired: 'Firmware version is required',
    fileRequired: 'Firmware file is required',
    uploadSuccess: 'Firmware uploaded successfully',
    deviceCodeRequired: 'Device code is required',
    // Device models and firmware types
    modelESP32S: 'ESP32-S',
    modelESP32C: 'ESP32-C',
    modelESP32D: 'ESP32-D',
    modelESP8266: 'ESP8266',
    typeESP32: 'ESP32',
    typeESP32S3: 'ESP32-S3',
    typeESP32C3: 'ESP32-C3'
  },
  system: {
    systemConfig: 'System Config',
    systemConfigTips: 'Manage core system parameters and global configurations for flexible behavior adjustment',
    systemConfigSubtitle: 'Manage system settings, security policies and feature configurations',
    basicSettings: 'Basic Settings',
    securitySettings: 'Security Settings',
    emailSettings: 'Email Settings',
    storageSettings: 'Storage Settings',
    systemName: 'System Name',
    systemVersion: 'System Version',
    companyName: 'Company Name',
    contactEmail: 'Contact Email',
    defaultLanguage: 'Default Language',
    timeZone: 'Time Zone',
    enterSystemName: 'Please enter system name',
    enterCompanyName: 'Please enter company name',
    enterContactEmail: 'Please enter contact email',
    enterValidEmail: 'Please enter a valid email address',
    enterSessionTimeout: 'Please enter session timeout',
    enterSmtpServer: 'Please enter SMTP server',
    enterSmtpPort: 'Please enter SMTP port',
    enterSenderEmail: 'Please enter sender email',
    alarmManagement: 'Alarm Management',
    alarmRules: 'Alarm Rules',
    alarmHistory: 'Alarm History',
    createAlarmRule: 'Create Alarm Rule',
    editAlarmRule: 'Edit Alarm Rule',
    alarmRuleName: 'Alarm Rule Name',
    alarmRuleDescription: 'Alarm Rule Description',
    alarmCondition: 'Alarm Condition',
    alarmThreshold: 'Alarm Threshold',
    alarmSeverity: 'Alarm Severity',
    alarmLevel: 'Alarm Level',
    alarmTrigger: 'Alarm Trigger',
    alarmAction: 'Alarm Action',
    alarmNotification: 'Alarm Notification',
    alarmStatus: 'Alarm Status',
    alarmEnabled: 'Alarm Enabled',
    alarmDisabled: 'Alarm Disabled',
    critical: 'Critical',
    major: 'Major',
    minor: 'Minor',
    warning: 'Warning',
    info: 'Info',
    clear: 'Clear',
    acknowledge: 'Acknowledge',
    assign: 'Assign',
    resolve: 'Resolve',
    escalate: 'Escalate',
    suppress: 'Suppress',
    unsuppress: 'Unsuppress',
    alarmDetail: 'Alarm Detail',
    alarmComments: 'Alarm Comments',
    alarmHistoryLog: 'Alarm History Log',
    alarmStatistics: 'Alarm Statistics',
    activeAlarms: 'Active Alarms',
    historicalAlarms: 'Historical Alarms',
    alarmTrend: 'Alarm Trend',
    alarmFrequency: 'Alarm Frequency',
    alarmMTTR: 'Mean Time To Resolution',
    alarmMTTA: 'Mean Time To Acknowledge',
    topAlarms: 'Top Alarms',
    alarmSource: 'Alarm Source',
    alarmCategory: 'Alarm Category',
    alarmEvent: 'Alarm Event',
    alarmTimestamp: 'Alarm Timestamp',
    alarmUpdateTime: 'Alarm Update Time',
    alarmAcknowledgedBy: 'Acknowledged By',
    alarmResolvedBy: 'Resolved By',
    alarmAssignedTo: 'Assigned To',
    alarmTimeout: 'Alarm Timeout',
    autoResolve: 'Auto Resolve',
    autoEscalate: 'Auto Escalate',
    alarmTemplate: 'Alarm Template',
    alarmRuleTemplate: 'Alarm Rule Template',
    importAlarmRules: 'Import Alarm Rules',
    exportAlarmRules: 'Export Alarm Rules',
    bulkOperation: 'Bulk Operation',
    selectAlarms: 'Select Alarms',
    acknowledgeSelected: 'Acknowledge Selected',
    resolveSelected: 'Resolve Selected',
    assignSelected: 'Assign Selected',
    deleteSelected: 'Delete Selected',
    alarmFilter: 'Alarm Filter',
    alarmSearch: 'Alarm Search',
    filterBySeverity: 'Filter by Severity',
    filterByStatus: 'Filter by Status',
    filterBySource: 'Filter by Source',
    filterByTime: 'Filter by Time',
    timeRange: 'Time Range',
    lastHour: 'Last Hour',
    lastDay: 'Last Day',
    lastWeek: 'Last Week',
    lastMonth: 'Last Month',
    customTime: 'Custom Time',
    startTime: 'Start Time',
    endTime: 'End Time',
    alarmNotFound: 'Alarm not found',
    alarmRuleNotFound: 'Alarm rule not found',
    alarmHistoryTips: 'Alarm history log, showing various system anomalies and resource usage warnings.',
    basicSettingsDesc: 'Manage system basic information, language and timezone settings',
    securitySettingsDesc: 'Configure login policy, password strength and session timeout',
    emailSettingsDesc: 'Configure SMTP service for system notification emails',
    storageSettingsDesc: 'Configure file storage path, quota and auto-cleanup cycle',
    serverSettingsDesc: 'Configure server WebSocket, MQTT gateway and security keys',
    enterServerWebsocketTip: 'WebSocket address used for device connections',
    alarmRules: 'Alarm Rules',
    alarmHistory: 'Alarm History',
    basicSettingsDesc: 'Manage system basic information, language and timezone settings',
    securitySettingsDesc: 'Configure login policy, password strength and session timeout',
    emailSettingsDesc: 'Configure SMTP service for system notification emails',
    storageSettingsDesc: 'Configure file storage path, quota and auto-cleanup cycle',
    serverSettingsDesc: 'Configure server WebSocket, MQTT gateway and security keys',
    enterServerWebsocketTip: 'WebSocket address used for device connections',
    batchResolveAlarms: 'Batch Resolve',
    batchDeleteAlarms: 'Batch Delete',
    alarmTitle: 'Alarm Title',
    alarmLevel: 'Alarm Level',
    alarmCategory: 'Category',
    alarmType: 'Alarm Type',
    alarmContent: 'Alarm Content',
    triggerTime: 'Trigger Time',
    resolveTime: 'Resolve Time',
    targetUser: 'Target User',
    targetModel: 'Target Model',
    systemLevel: 'System Level',
    statusUnresolved: 'Unresolved',
    statusIgnored: 'Ignored',
    statusResolved: 'Resolved',
    resolve: 'Resolve',
    resolveAlarm: 'Resolve Alarm',
    batchResolve: 'Batch Resolve',
    confirmBatchResolve: 'Are you sure you want to mark the selected alarms as resolved?',
    alarmDetail: 'Alarm Detail',
    inputTitle: 'Please enter alarm title',
    selectLevel: 'Please select alarm level',
    jobManagementTips: 'Manage scheduled tasks running in the system background, supporting dynamic modification of Cron expressions, pausing, resuming, and manual execution.',
    jobLogTips: 'View execution history of scheduled tasks, including status, duration, and error messages.',
    beanName: 'Bean Name',
    jobParams: 'Parameters',
    cronExpression: 'Cron Expression',
    jobLog: 'Job Logs',
    runOnce: 'Run Once',
    pause: 'Pause',
    resume: 'Resume',
    statusNormal: 'Normal',
    statusPaused: 'Paused',
    inputBeanName: 'Please enter bean name',
    inputJobParams: 'Please enter job parameters',
    inputCronExpression: 'Please enter Cron expression',
    cronOnline: 'Online Cron Generator',
    confirmRunOnce: 'Are you sure you want to run this task once?',
    jobId: 'Job ID',
    inputJobId: 'Please enter job ID',
    consumeTime: 'Duration',
    executionTime: 'Execution Time',
    jobLogDetail: 'Job Log Detail',
    errorMessage: 'Error Message',
    action: 'Action',
    createTime: 'Create Time',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    batchExport: 'Batch Export',
    unreadNotifications: 'unread notifications',
    logId: 'Log ID',
    jobId: 'Job ID',
    category: 'Category',
    level: 'Level',
    type: 'Type',
    systemLevel: 'System Level',
    resourceLevel: 'Resource Level',
    thresholdTrigger: 'Threshold',
    changeTrigger: 'Change',
    trendTrigger: 'Trend',
    BALANCE: 'Balance',
    QUOTA: 'Quota',
    triggerConditions: 'Trigger Conditions',
    SYSTEM: 'System',
    RESOURCE: 'Resource',
    INFO: 'Info',
    WARNING: 'Warning',
    WARN: 'Warning',
    ERROR: 'Error',
    CRITICAL: 'Critical',
    FATAL: 'Fatal',
    DEBUG: 'Debug',

    // Alarm Management
    alarmManagementTips: 'Alarm Management History',
    confirmBatchResolve: 'Are you sure you want to mark selected alarms as resolved?',
    batchResolve: 'Batch Resolve',
    alarmDetail: 'Alarm Detail',
    alarmTitle: 'Alarm Title',
    alarmLevel: 'Alarm Level',
    alarmCategory: 'Alarm Category',
    alarmType: 'Alarm Type',
    alarmContent: 'Alarm Content',
    triggerTime: 'Trigger Time',
    resolveTime: 'Resolve Time',
    statusUnresolved: 'Unresolved',
    statusIgnored: 'Ignored',
    statusResolved: 'Resolved',
    batchResolveAlarms: 'Batch Resolve',
    batchDeleteAlarms: 'Batch Delete',
    confirmBatchDeleteAlarms: 'Are you sure you want to batch delete selected alarm logs?',
    alarmHistoryTips: 'Alarm history records, view all alarm trigger logs in the system.',

    // Log Management
    notificationManagementTips: 'Manage system message delivery with tracking, status resending, and batch processing',
    notificationSearchPlaceholder: 'Search notification title or content',
    selectNotificationType: 'Select notification type',
    selectNotificationStatus: 'Select notification status',
    selectNotificationPriority: 'Select notification priority',
    unreadNotifications: 'Unread Notifications',
    batchOperations: 'Batch Operations',
    markAsRead: 'Mark as Read',
    notificationType: 'Notification Type',
    notificationTitle: 'Notification Title',
    unreadNotification: 'Unread',
    readNotification: 'Read',
    deletedNotification: 'Deleted',
    notificationContent: 'Notification Content',
    sender: 'Sender',
    recipient: 'Recipient',
    allUsers: 'All Users',
    notificationChannels: 'Notification Channels',
    notificationPriority: 'Priority',
    createdAt: 'Created At',
    notificationStatus: 'Notification Status',
    notificationDetail: 'Notification Detail',
    channels: 'Channels',
    sendNotification: 'Send Notification',
    enterNotificationTitle: 'Please enter notification title',
    enterNotificationContent: 'Please enter notification content',
    specificUser: 'Specific User',
    enterRecipientUsername: 'Please enter recipient username',
    lowPriority: 'Low Priority',
    mediumPriority: 'Medium Priority',
    highPriority: 'High Priority',
    updateNotification: 'Update Notification',
    editNotification: 'Edit Notification',
    systemNotification: 'System Notification',
    alertNotification: 'Alert Notification',
    reminderNotification: 'Reminder Notification',
    infoNotification: 'Info Notification',
    systemChannel: 'System Message',
    emailChannel: 'Email',
    smsChannel: 'SMS',
    pushChannel: 'Push',
    systemNotification: 'System Notification',
    systemNotificationTips: 'Publish announcements system-wide or to specific scopes to ensure accurate information delivery',
    notificationTemplate: 'Notification Template',
    notificationTemplateTips: 'Customize notification content templates with multi-language dynamic rendering and parameterized replacement',
    notificationChannelManagement: 'Notification Channel Management',
    notificationChannelTips: 'Configure system notification delivery channels via email, SMS, WeChat, and third-party services',
    notificationChannelManagementSubtitle: 'Configure system notification channels, supporting Email, SMS, WeChat, etc.',
    info: 'Info',
     count: 'Count',
     testAlarmMessage: 'This will send a test notification for alarm rule:',
     testAlarmConfirm: 'Are you sure you want to test this alarm rule?',
     alarmDetail: 'Alarm Detail',
     triggerConditions: 'Trigger Conditions',
     noDescription: 'No Description',
     updateAlarmStatusSuccess: 'Alarm status updated successfully',
     updateAlarmStatusFailed: 'Failed to update alarm status',
  },
  // Mock alarm rule names
     cpuHighUsageAlarm: 'CPU High Usage Alarm',
     cpuHighUsageAlarmDesc: 'Triggered when CPU usage exceeds threshold',
     memoryHighUsageAlarm: 'Memory High Usage Alarm',
     memoryHighUsageAlarmDesc: 'Triggered when memory usage exceeds threshold',
     deviceOfflineAlarm: 'Device Offline Alarm',
     deviceOfflineAlarmDesc: 'Triggered when devices go offline',
     // Threshold trigger types
     thresholdTrigger: 'Threshold Trigger',
     changeTrigger: 'Change Trigger',
     trendTrigger: 'Trend Trigger',
     enterSenderPassword: 'Please enter sender password',
     enterStoragePath: 'Please enter storage path',
     // Notification Management translations
     editNotification: 'Edit Notification',
     updateNotificationSuccess: 'Notification updated successfully',
     updateNotificationFailed: 'Failed to update notification',
     selectNotificationsFirst: 'Please select notifications first',
     batchMarkAsReadConfirm: 'Are you sure you want to mark the selected notifications as read?',
     batchMarkAsUnreadConfirm: 'Are you sure you want to mark the selected notifications as unread?',
     noUnreadNotificationsSelected: 'No unread notifications selected',
     noReadNotificationsSelected: 'No read notifications selected',
     batchMarkAsReadSuccess: 'Batch mark as read successful',
     batchMarkAsUnreadSuccess: 'Batch mark as unread successful',
     batchMarkAsReadFailed: 'Batch mark as read failed',
     batchMarkAsUnreadFailed: 'Batch mark as unread failed',
     batchDelete: 'Batch Delete',
     batchDeleteNotificationConfirm: 'Are you sure you want to delete the selected notifications?',
     deleteNotificationConfirm: 'Are you sure you want to delete this notification?',
     deleteNotificationSuccess: 'Notification deleted successfully',
     unreadNotifications: 'Unread Notifications',
     markAsReadConfirm: 'Are you sure you want to mark this notification as read?',
     markAsReadSuccess: 'Mark as read successful',
     markAsReadFailed: 'Mark as read failed',
     passwordPolicy: 'Password Policy',
    simple: 'Simple',
    medium: 'Medium',
    strong: 'Strong',
    sessionTimeout: 'Session Timeout',
    maxLoginAttempts: 'Max Login Attempts',
    minutes: 'minutes',
    times: 'times',
    days: 'days',
    smtpServer: 'SMTP Server',
    smtpPort: 'SMTP Port',
    senderEmail: 'Sender Email',
    senderPassword: 'Sender Password',
    testEmail: 'Test Email',
    storagePath: 'Storage Path',
    maxFileSize: 'Max File Size',
    cleanupDays: 'Cleanup Days',
    cleanupStorage: 'Cleanup Storage',
    enterMaxFileSize: 'Please enter max file size',
    emailTestSuccess: 'Email test successful',
    emailTestFailed: 'Email test failed',
    cleanupSuccess: 'Cleanup successful',
    cleanupFailed: 'Cleanup failed',
    megabytes: 'MB',
    chinese: 'Chinese',
    english: 'English',
    gmt8ChinaTime: 'GMT+8 China Standard Time',
    gmt5UsEastern: 'GMT-5 US Eastern Time',
    gmt0Greenwich: 'GMT+0 Greenwich Time',
    gmt9Japan: 'GMT+9 Japan Standard Time',
    logManagement: 'Log Management',
    logManagementSubtitle: 'View and manage system logs',
    notificationChannelManagement: 'Notification Channel Management',
    notificationChannelManagementSubtitle: 'Configure system notification channels, supporting Email, SMS, WeChat, etc.',
    systemChannel: 'System Message',
    systemChannelDescription: 'Send notifications through the internal system message center',
    emailChannel: 'Email Notification',
    emailChannelDescription: 'Send email notifications through an SMTP server',
    emailSettings: 'Email Settings',
    smtpHost: 'SMTP Server',
    enterSmtpHost: 'Please enter SMTP server address',
    smtpPort: 'SMTP Port',
    smtpUsername: 'SMTP Username',
    enterSmtpUsername: 'Please enter SMTP username',
    smtpPassword: 'SMTP Password',
    enterSmtpPassword: 'Please enter SMTP password',
    smtpEncryption: 'Encryption',
    selectSmtpEncryption: 'Please select encryption method',
    noEncryption: 'No Encryption',
    senderName: 'Sender Name',
    enterSenderName: 'Please enter sender name',
    testEmail: 'Test Email',
    smsChannel: 'SMS Notification',
    smsChannelDescription: 'Send SMS notifications through a third-party SMS provider',
    smsSettings: 'SMS Settings',
    apiKey: 'API Key',
    enterApiKey: 'Please enter API Key',
    apiSecret: 'API Secret',
    enterApiSecret: 'Please enter API Secret',
    apiEndpoint: 'API Endpoint',
    enterApiEndpoint: 'Please enter API Endpoint',
    senderId: 'Sender ID',
    enterSenderId: 'Please enter Sender ID',
    testSms: 'Test SMS',
    wechatChannel: 'WeChat Notification',
    wechatChannelDescription: 'Send notifications through WeChat official account template messages',
    wechatSettings: 'WeChat Settings',
    appId: 'AppID',
    enterAppId: 'Please enter AppID',
    appSecret: 'AppSecret',
    enterAppSecret: 'Please enter AppSecret',
    templateId: 'Template ID',
    enterTemplateId: 'Please enter Template ID',
    accessToken: 'Access Token',
    enterAccessToken: 'Please enter Access Token',
    testWechat: 'Test WeChat',
    recipientEmail: 'Recipient Email',
    enterRecipientEmail: 'Please enter recipient email',
    recipientPhone: 'Recipient Phone',
    enterRecipientPhone: 'Please enter recipient phone',
    recipientOpenId: 'Recipient OpenID',
    enterRecipientOpenId: 'Please enter recipient OpenID',
    testMessage: 'Test Message',
    enterTestMessage: 'Please enter test message content',
    testNotification: 'Test Notification',

    // Notification Template
    notificationTemplate: 'Notification Template',
    createTemplate: 'Create Template',
    editTemplate: 'Edit Template',
    templateName: 'Template Name',
    templateNamePlaceholder: 'Please enter template name',
    selectTemplateType: 'Please select template type',
    templateContentPlaceholder: 'Please enter template content, supports {variable} placeholders',
    templateHelpText: 'Supports {username}, {title}, {content}, {time} and other variable placeholders',
    templateNameRequired: 'Please enter template name',
    templateTypeRequired: 'Please select template type',
    templateContentRequired: 'Please enter template content',
    templateChannelsRequired: 'Please select notification channels',
    enableSelected: 'Enable Selected',
    disableSelected: 'Disable Selected',
    deleteSelected: 'Delete Selected',
    notificationChannels: 'Notification Channels',
    updateChannelSuccess: 'Channel configuration updated successfully',
    updateChannelFailed: 'Failed to update channel configuration',
    saveChannelSuccess: 'Channel configuration saved successfully',
    saveChannelFailed: 'Failed to save channel configuration',
    enterRecipient: 'Please enter recipient',
    testNotificationSuccess: 'Test notification sent successfully',
    testNotificationFailed: 'Failed to send test notification',

    logType: 'Log Type',
    selectLogType: 'Select Log Type',
    totalLogs: 'Total Logs',
    successLogs: 'Success Logs',
    failedLogs: 'Failed Logs',
    userOperationLog: 'User Logs',
    roleOperationLog: 'Role Logs',
    deviceOperationLog: 'Device Logs',
    roleName: 'Role Name',
    permissionChange: 'Permissions Changed',
    deviceId: 'Device ID',
    operationStatus: 'Status',
    operationContent: 'Content',
    operationTime: 'Time',
    exportPdf: 'Export PDF',
    exportExcel: 'Export Excel',
    batchExport: 'Batch Export',
    exportLogs: 'Export Logs',
    exporting: 'Exporting...',
    exportingSingle: 'Exporting single record...',
    batchExporting: 'Batch exporting...',
    exportSuccess: 'Export successful',
    exportFailed: 'Export failed',
    batchExportSuccess: 'Batch export successful',
    batchExportFailed: 'Batch export failed',
    exportingSingle: 'Exporting single log...',
    exportSingleSuccess: 'Export successful',
    exportSingleFailed: 'Export failed',
    confirmDeleteLog: 'Are you sure you want to delete this log?',
    deleteLogSuccess: 'Deleted successfully',
    deleteLogFailed: 'Delete failed',
    totalLogs: 'Total Logs',
    successLogs: 'Success Logs',
    failedLogs: 'Failed Logs',
    logDetail: 'Log Detail',
    logType: 'Log Type',
    targetType: 'Target Type',
    targetId: 'Target ID',
    userAgent: 'User Agent',
    getLogsFailed: 'Failed to get log list',
    startTime: 'Start Time',
    endTime: 'End Time',
    usernamePlaceholder: 'Please enter username',
    ipPlaceholder: 'Please enter IP address',
    success: 'Success',
    fail: 'Fail',
    clear: 'Clear',
    confirmClearLogs: 'Are you sure you want to clear all logs? This action cannot be undone.',
    clearSuccess: 'Logs cleared successfully',
    clearFailed: 'Failed to clear logs',
    copyError: 'Copy Error',
    copySuccess: 'Copied successfully',
    errorDetail: 'Error Details',
    viewUser: 'View User',
    viewDevice: 'View Device',
    viewAgent: 'View Agent',
    viewRole: 'View Role',

    // Notification Management
    notificationManagementTips: 'Manage all notification records in the system',
    notificationSearchPlaceholder: 'Search title or content',
    batchOperations: 'Batch Operations',
    notificationType: 'Type',
    notificationTitle: 'Title',
    notificationContent: 'Content',
    sender: 'Sender',
    recipient: 'Recipient',
    allUsers: 'All Users',
    notificationPriority: 'Priority',
    unreadNotification: 'Unread',
    markedAsRead: 'Marked as read',
    confirmDeleteNotification: 'Are you sure you want to delete the selected notifications?',
    notificationDetail: 'Notification Detail',
    sendNotification: 'Send Notification',
    selectNotificationType: 'Select type',
    selectNotificationStatus: 'Select status',
    selectNotificationPriority: 'Select priority',
    highPriority: 'High',
    mediumPriority: 'Medium',
    lowPriority: 'Low',
    systemNotification: 'System',
    alertNotification: 'Alert',
    messageNotification: 'Message',
    systemNotificationTips: 'Manage global notifications, alerts, and business reminders issued by the system, support batch processing and status tracking',
    systemConfigTips: 'Configure global operating environments such as basic system information, security policies, email services, and storage rules',
    serverMonitorTips: 'Real-time display of server CPU, memory, disk, and JVM operation indicators to ensure high performance and stable system operation',
    jobManagementTips: 'Configure system background automated tasks, support dynamic modification of Cron expressions, job scheduling monitoring, and execution log auditing',
    jobLogTips: 'View the execution history of scheduled tasks, including success status, execution duration, and exception information',
    logManagementTips: 'Audit system operation logs, support multi-dimensional tracking of operations and exceptions by user, role, device, and agent',
    dictManagementTips: 'Maintain system global data dictionaries, achieving unified management and rapid reuse of business fields through dynamic configuration',
    systemParamsTips: 'Centrally manage core parameters and configuration items during system runtime, support dynamic effectiveness to meet flexible business needs',
    appearanceSettings: 'Appearance Settings',
    themeColor: 'Theme Color',
    notificationSettings: 'Notification Settings',
    emailNotifications: 'Email Notifications',
    emailNotificationsTip: 'Receive important notifications via email',
    smsNotifications: 'SMS Notifications',
    smsNotificationsTip: 'Receive important notifications via SMS',
    privacySettings: 'Privacy Settings',
    publicProfile: 'Public Profile',
    publicProfileTip: 'Allow other users to view your profile',
    jobManagementTips: 'Manage system background scheduled jobs',
    jobLogTips: 'View scheduled job execution logs',
    logManagementTips: 'View and manage system operation logs',
    notificationTemplateTips: 'Configure notification push templates',
    notificationChannelTips: 'Manage notification delivery channels',
    batchExportFailed: 'Batch export failed',
    exportSingleSuccess: 'Export successful',
    exportSingleFailed: 'Export failed',
    selectLogsFirst: 'Please select logs to export first',
    confirmDeleteLog: 'Are you sure to delete this log record?',
    deleteLogSuccess: 'Log deleted successfully',
    deleteLogFailed: 'Failed to delete log',
    notificationTemplate: 'Notification Template',
    systemSettings: 'System Settings',
    operationLogs: 'Operation Logs',
    securityLogs: 'Security Logs',
    exportLogs: 'Export Logs',
    notificationSettings: 'Notification Settings',
    templateName: 'Template Name',
    templateContent: 'Template Content',
    createTemplate: 'Create Template',
    editTemplate: 'Edit Template',
    exporting: 'Exporting...',
    alarmManagement: 'Alarm Management',
    alarmManagementSubtitle: 'Manage and configure system alarm rules',
    alarmRules: 'Alarm Rules',
    createAlarm: 'Create Alarm Rule',
    editAlarm: 'Edit Alarm Rule',
    alarmName: 'Alarm Name',
    enterAlarmName: 'Please enter alarm name',
    alarmNameLength: 'Alarm name length should be 2-100 characters',
    alarmNamePlaceholder: 'Please enter alarm name',
    alarmDescriptionPlaceholder: 'Please enter alarm description',
    severity: 'Severity',
    selectSeverity: 'Please select severity',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    info: 'Info',
    critical: 'Critical',
    triggerType: 'Trigger Type',
    selectTriggerType: 'Please select trigger type',
    thresholdTrigger: 'Threshold Trigger',
    changeTrigger: 'Change Trigger',
    trendTrigger: 'Trend Trigger',
    threshold: 'Threshold',
    enterThreshold: 'Please enter threshold',
    comparisonOperator: 'Comparison Operator',
    selectComparisonOperator: 'Please select comparison operator',
    selectUnit: 'Please select unit',
    thresholdPlaceholder: 'Please enter threshold',
    durationPlaceholder: 'Please enter duration',
    count: 'Count',
    triggerConditions: 'Trigger Conditions',
    greaterThan: 'Greater Than',
    lessThan: 'Less Than',
    equalTo: 'Equal To',
    notEqualTo: 'Not Equal To',
    greaterThanOrEqual: 'Greater Than or Equal To',
    lessThanOrEqual: 'Less Than or Equal To',
    resourceType: 'Resource Type',
    selectResourceType: 'Please select resource type',
    cpu: 'CPU Usage',
    memory: 'Memory Usage',
    disk: 'Disk Usage',
    network: 'Network Traffic',
    userCount: 'User Count',
    deviceCount: 'Device Count',
    apiCalls: 'API Calls',
    notificationChannels: 'Notification Channels',
    selectNotificationChannels: 'Please select notification channels',
    systemMessage: 'System Message',
    systemChannel: 'System Message',
    email: 'Email',
    emailChannel: 'Email',
    sms: 'SMS',
    smsChannel: 'SMS',
    wechat: 'WeChat',
    wechatChannel: 'WeChat',
    testAlarm: 'Test Alarm',
    test: 'Test',
    createAlarmRule: 'Create Alarm Rule',
    alarmDetail: 'Alarm Detail',
    enableAlarm: 'Enable Alarm',
    disableAlarm: 'Disable Alarm',
    alarmEnabled: 'Alarm Enabled',
    alarmDisabled: 'Alarm Disabled',
    createAlarmSuccess: 'Alarm rule created successfully',
    updateAlarmSuccess: 'Alarm rule updated successfully',
    saveAlarmFailed: 'Failed to save alarm rule',
    deleteAlarmConfirm: 'Are you sure you want to delete alarm rule "{name}"?',
    deleteAlarmSuccess: 'Alarm rule deleted successfully',
    deleteAlarmFailed: 'Failed to delete alarm rule',
    batchEnableAlarms: 'Batch Enable Alarms',
    batchDisableAlarms: 'Batch Disable Alarms',
    batchDeleteAlarms: 'Batch Delete Alarms',
    batchEnableAlarmsConfirm: 'Are you sure you want to batch enable {count} alarm rules?',
    batchDisableAlarmsConfirm: 'Are you sure you want to batch disable {count} alarm rules?',
    batchDeleteAlarmsConfirm: 'Are you sure you want to batch delete {count} alarm rules?',
    batchEnableAlarmsSuccess: 'Batch enable alarm rules successful',
    batchDisableAlarmsSuccess: 'Batch disable alarm rules successful',
    batchDeleteAlarmsSuccess: 'Batch delete alarm rules successful',
    batchAlarmsFailed: 'Batch operation on alarm rules failed',
    testAlarmSuccess: 'Alarm test successful',
    testAlarmFailed: 'Alarm test failed',
    testAlarmMessage: 'This will send a test alarm message, are you sure you want to continue?',
    testAlarmConfirm: 'Test alarm will be sent to all configured channels',
    alarmNotFound: 'Alarm rule not found',
    getAlarmRulesFailed: 'Failed to get alarm rules list',
    noSelectedAlarms: 'Please select alarm rules to operate',
    cpuHighUsageAlarm: 'CPU High Usage Alarm',
    cpuHighUsageAlarmDesc: 'Trigger alarm when CPU usage exceeds threshold',
    memoryHighUsageAlarm: 'Memory High Usage Alarm',
    memoryHighUsageAlarmDesc: 'Trigger alarm when memory usage exceeds threshold',
    deviceOfflineAlarm: 'Device Offline Alarm',
    deviceOfflineAlarmDesc: 'Trigger alarm when device is offline for more than specified time',
    updateAlarmStatusSuccess: 'Alarm status updated successfully',
    updateAlarmStatusFailed: 'Failed to update alarm status',
    editAlarmRule: 'Edit Alarm Rule',
    confirmDeleteAlarm: 'Are you sure you want to delete this alarm rule?',
    warning: 'Warning',
    alarmRuleForm: 'Alarm Rule Form',
    basicSettings: 'Basic Settings',
    // Notification Management
    notificationManagement: 'Notification Management',
    notificationManagementSubtitle: 'Manage and view system notifications, supporting multi-condition filtering and batch operations',
    notificationSearchPlaceholder: 'Search notification title or content',
    selectNotificationType: 'Select notification type',
    selectNotificationStatus: 'Select notification status',
    selectNotificationPriority: 'Select notification priority',
    sendNotification: 'Send Notification',
    updateNotification: 'Update Notification',
    batchActions: 'Batch Actions',
    markAsRead: 'Mark as Read',
    markAsUnread: 'Mark as Unread',
    unreadNotification: 'Unread',
    readNotification: 'Read',
    deletedNotification: 'Deleted',
    systemNotification: 'System Notification',
    alertNotification: 'Alert Notification',
    reminderNotification: 'Reminder Notification',
    infoNotification: 'Info Notification',
    notificationDetail: 'Notification Detail',
    
    // Log operation types
    actions: {
      userLogin: 'User Login',
      userLogout: 'User Logout',
      viewUserList: 'View User List',
      createUser: 'Create User',
      editUserInfo: 'Edit User Info',
      deleteUser: 'Delete User',
      enableUser: 'Enable User',
      disableUser: 'Disable User',
      batchDeleteUser: 'Batch Delete Users',
      viewUserDetail: 'View User Detail',
      viewDeviceList: 'View Device List',
      addDevice: 'Add Device',
      editDeviceInfo: 'Edit Device Info',
      deleteDevice: 'Delete Device',
      deviceOnline: 'Device Online',
      deviceOffline: 'Device Offline',
      deviceRestart: 'Device Restart',
      firmwareUpgrade: 'Firmware Upgrade',
      bindDeviceToUser: 'Bind Device to User',
      unbindDevice: 'Unbind Device',
      viewAlarmList: 'View Alarm List',
      createAlarmRule: 'Create Alarm Rule',
      editAlarmRule: 'Edit Alarm Rule',
      deleteAlarmRule: 'Delete Alarm Rule',
      enableAlarmRule: 'Enable Alarm Rule',
      disableAlarmRule: 'Disable Alarm Rule',
      processAlarm: 'Process Alarm',
      ignoreAlarm: 'Ignore Alarm',
      viewNotificationList: 'View Notification List',
      sendNotification: 'Send Notification',
      editNotification: 'Edit Notification',
      deleteNotification: 'Delete Notification',
      batchMarkRead: 'Batch Mark as Read',
      batchDeleteNotification: 'Batch Delete Notifications',
      systemStartup: 'System Startup',
      systemShutdown: 'System Shutdown',
      systemRestart: 'System Restart',
      dbBackup: 'Database Backup',
      systemUpdate: 'System Update',
      clearCache: 'Clear Cache',
      systemMaintenance: 'System Maintenance',
      dbConnectFailed: 'Database Connection Failed',
      apiCallFailed: 'API Call Failed',
      permVerifyFailed: 'Permission Verification Failed',
      fileUploadFailed: 'File Upload Failed',
      emailSendFailed: 'Email Sending Failed',
      userAuthFailed: 'User Authentication Failed',
      paramVerifyFailed: 'Parameter Verification Failed',
      networkTimeout: 'Network Timeout'
    },
    
    // Log detail templates
    templates: {
      loginSuccess: 'User {username} logged in successfully',
      defaultAction: 'User {username} performed {action} operation',
      loginFromIp: 'User {username} logged in from IP {ip}',
      loginVerified: 'User {username} login verification passed',
      logoutNormal: 'User {username} logged out normally',
      logoutTimeout: 'User {username} logged out due to session timeout',
      viewUserListDesc: 'User {username} viewed user management page',
      searchUserListDesc: 'User {username} searched user list',
      createNewAccount: 'User {username} created a new account',
      adminCreateUser: 'Admin created user: {targetUser}',
      updateUserProfile: 'User {username} updated profile',
      adminModifyUser: 'Admin modified user {targetUser} info',
      adminDeleteUser: 'Admin deleted user {targetUser}',
      userDeleteAccount: 'User {username} deleted account',
      adminEnableUser: 'Admin enabled user {targetUser}',
      userStatusActivated: 'User {username} status activated',
      adminDisableUser: 'Admin disabled user {targetUser}',
      userStatusDeactivated: 'User {username} status deactivated',
      adminBatchDeleteUsers: 'Admin batch deleted {count} user accounts',
      userBatchDelete: 'User {username} performed batch delete',
      viewUserDetailDesc: 'User {username} viewed user {targetUser} details',
      adminViewUserInfo: 'Admin viewed user info',
      viewDeviceListDesc: 'User {username} viewed device management page',
      searchDeviceListDesc: 'User {username} searched device list',
      addNewDevice: 'User {username} added a new device',
      adminBindDevice: 'Admin bound device to user',
      updateDeviceInfo: 'User {username} updated device info',
      adminModifyDevice: 'Admin modified device {deviceId} details',
      adminDeleteDevice: 'Admin deleted device {deviceId}',
      userRemoveDevice: 'User {username} removed device',
      deviceConnectSuccess: 'Device {deviceId} connected to server',
      deviceOnlineNotice: 'Device online notice',
      deviceDisconnect: 'Device {deviceId} disconnected',
      deviceOfflineAlarm: 'Device offline alarm',
      userRestartDevice: 'User {username} restarted device {deviceId}',
      deviceExecuteRestart: 'Device {deviceId} executed restart',
      firmwareUpgradeTo: 'Device {deviceId} firmware upgraded to version {version}',
      userUpgradeFirmware: 'User {username} upgraded device firmware',
      adminBindToUser: 'Admin bound device {deviceId} to user {targetUser}',
      userBindDevice: 'User {username} bound device',
      adminUnbindDevice: 'Admin unbound device {deviceId} from user',
      userUnbindDevice: 'User {username} unbound device',
      viewAlarmListDesc: 'User {username} viewed alarm management page',
      filterAlarmRecords: 'User {username} filtered alarm records',
      createNewAlarmRule: 'User {username} created a new alarm rule',
      adminAddAlarmMonitor: 'Admin added alarm monitor',
      modifyAlarmConfig: 'User {username} modified alarm rule configuration',
      adminUpdateAlarmSettings: 'Admin updated alarm settings',
      userDeleteAlarmRule: 'User {username} deleted alarm rule',
      adminRemoveAlarmMonitor: 'Admin removed alarm monitor',
      userEnableAlarmRule: 'User {username} enabled alarm rule',
      adminActivateAlarmMonitor: 'Admin activated alarm monitor',
      userDisableAlarmRule: 'User {username} disabled alarm rule',
      adminDeactivateAlarmMonitor: 'Admin deactivated alarm monitor',
      userProcessAlarm: 'User {username} processed alarm event',
      adminConfirmAlarmProcessed: 'Admin confirmed alarm processed',
      userIgnoreAlarm: 'User {username} ignored alarm',
      adminIgnoreAlarmEvent: 'Admin ignored alarm event',
      viewNotificationCenter: 'User {username} viewed notification center',
      browseMessageList: 'User {username} browsed message list',
      userSendNotification: 'User {username} sent system notification',
      adminPublishNotification: 'Admin published notification',
      userModifyNotification: 'User {username} modified notification',
      adminUpdateNotification: 'Admin updated notification',
      userDeleteNotification: 'User {username} deleted notification',
      adminRemoveNotification: 'Admin removed notification',
      userBatchMarkRead: 'User {username} batch marked {count} notifications as read',
      adminBatchMarkRead: 'Admin performed batch mark as read',
      userBatchDeleteNotifications: 'User {username} batch deleted {count} notifications',
      adminBatchDeleteNotifications: 'Admin performed batch delete',
      systemStartupComplete: 'System service startup complete',
      modulesLoadNormal: 'All modules loaded normally',
      systemInitSuccess: 'System initialization successful',
      systemShutdownNormal: 'System shutdown normally',
      servicesStopComplete: 'Services stopped completely',
      systemExecuteRestart: 'System executed restart',
      servicesRestarting: 'Services restarting',
      dbBackupSuccess: 'Database backup task successful',
      backupFileGenerated: 'Backup file generated',
      dataBackupComplete: 'Data backup complete',
      systemVersionUpdate: 'System version updated to {version}',
      systemUpgradeComplete: 'System upgrade complete',
      systemCacheClearComplete: 'System cache cleanup complete',
      cacheFilesCleared: 'Cache files cleared',
      systemEnterMaintenance: 'System entered maintenance mode',
      maintenanceTaskRunning: 'Maintenance task running',
      dbConnectTimeout: 'Database connection timeout: {error}',
      dbConnectUnable: 'Unable to connect to database server',
      dbConnectException: 'Database connection exception',
      apiCallFailedError: 'External API call failed: {error}',
      interfaceRequestTimeout: 'Interface request timeout',
      serviceResponseAbnormal: 'Service response abnormal',
      userPermInsufficient: 'User {username} insufficient permissions',
      accessDeniedPermFailed: 'Access denied: permission verification failed',
      fileUploadFailedError: 'File upload failed: {error}',
      fileFormatUnsupported: 'File format not supported',
      uploadFileTooLarge: 'Upload file too large',
      emailSendFailedError: 'Email sending failed: {error}',
      smtpConnectFailed: 'SMTP connection failed',
      emailQueueAbnormal: 'Email queue abnormal',
      userAuthFailedUser: 'User {username} authentication failed',
      loginCredentialsError: 'Login credentials error',
      tokenVerifyFailed: 'Token verification failed',
      paramVerifyFailedError: 'Request parameter verification failed: {error}',
      inputDataFormatError: 'Input data format error',
      networkTimeoutError: 'Network connection timeout: {error}',
      requestResponseTimeout: 'Request response timeout'
    },
  roleLog: {
    operatorName: 'Operator',
    operatorNamePlaceholder: 'Please enter operator name',
    operationType: 'Operation Type',
    operationTypePlaceholder: 'Please select operation type',
    operator: 'Operator',
    type: 'Type',
    content: 'Content',
    result: 'Result',
    time: 'Time'
  },
  permissionManagement: {
    title: 'Permission Management',
    searchPlaceholder: 'Search by name or path',
    expandAll: 'Expand All',
    collapseAll: 'Collapse All',
    batchOperation: 'Batch Operation',
    checkAll: 'Check All',
    checkNone: 'Invert Selection',
    expandLevel1: 'Expand Level 1',
    editPermission: 'Edit Permission',
    addPermission: 'Add Permission',
    associatedRoles: 'Associated Roles',
    parentName: 'Parent Permission',
    root: 'Root',
    name: 'Name',
    type: 'Type',
    directory: 'Directory',
    menu: 'Menu',
    button: 'Button',
    url: 'Route Path',
    permission: 'Permission Identifier',
    icon: 'Icon',
    sort: 'Sort',
    description: 'Detailed Description',
    createTime: 'Created Time',
    updateTime: 'Last Update',
    pleaseSelectNode: 'Please select a permission item from the left to view or edit',
    nameRequired: 'Please enter name',
    typeRequired: 'Please select type',
    permissionRequired: 'Please enter permission identifier',
    fetchListError: 'Failed to fetch permission list',
    unknown: 'Unknown',
    deleteConfirm: 'Are you sure you want to delete permission "{name}"? It cannot be deleted if it has sub-items.',
    levelAdjustSuccess: 'Level adjusted successfully',
    levelAdjustError: 'Failed to adjust level',
    quickFill: 'Quick Fill',
    actionList: 'List (list)',
    actionInfo: 'Detail (info)',
    actionSave: 'Save (save)',
    actionUpdate: 'Update (update)',
    actionDelete: 'Delete (delete)',
    actionView: 'View (view)',
    permissionTip: 'Suggested format: sys:module:action (e.g., sys:user:save)',
    commonIcons: 'Common Icons',
    autoGenerateUrl: 'Auto Generate URL',
    urlTip: 'Route path for the menu, e.g., /sys/user'
  },
  agent: {
    agentListTips: 'Agent List',
    createAgent: 'Create Agent',
    editAgent: 'Edit Agent',
    agentName: 'Agent Name',
    agentCode: 'Agent Code',
    userId: 'User ID',
    agentId: 'Agent ID',
    quickStartTemplate: 'Quick Start from Template',
    selectTemplatePlaceholder: 'Please select a template',
    corePersona: 'Core Persona',
    agentIdentity: 'Agent Identity',
    avatar: 'Agent Avatar',
    uploadAvatar: 'Upload Avatar',
    avatarSizeTip: 'Recommended 1:1 ratio, supports JPG/PNG/WEBP, max 2MB',
    enterAgentName: 'Please enter agent name',
    inputAgentName: 'Please enter agent name',
    roleDescription: 'Role Description (System Prompt)',
    systemPromptPlaceholder: 'Enter system prompt to define agent role, personality and behavior...',
    summaryMemory: 'Summary Memory',
    summaryMemoryPlaceholder: 'Enter summary memory to help agent remember important context...',
    capabilities: 'Capabilities & Models',
    capabilitiesTag: 'Core Config',
    modelStack: 'Model Stack',
    llmModel: 'LLM Model',
    vllmModel: 'VLLM Model',
    asrModel: 'ASR Model',
    vadModel: 'VAD Model',
    memoryModel: 'Memory Model',
    intentModel: 'Intent Model',
    voiceConfig: 'Voice Config',
    ttsModel: 'TTS Model',
    ttsVoice: 'TTS Voice',
    selectTtsModelFirst: 'Please select TTS model first',
    advancedSettings: 'Advanced Settings',
    chatHistoryStrategy: 'Chat History Strategy',
    noRecord: 'No Record',
    onlyText: 'Text Only',
    textAndVoice: 'Text & Voice',
    extendedFeatures: 'Extended Features',
    pluginConfig: 'Plugin Config',
    chatHistoryQuery: 'Chat History Query',
    selectAgent: 'Select Agent',
    templateManagement: 'Template Management',
    createTemplate: 'Create Template',
    editTemplate: 'Edit Template',
    templateName: 'Template Name',
    inputTemplateName: 'Please enter template name',
    allCategories: 'All Categories',
    general: 'General',
    customerService: 'Customer Service',
    education: 'Education',
    entertainment: 'Entertainment',
    others: 'Others',
    category: 'Category',
    selectCategory: 'Please select category',
    systemPrompt: 'System Prompt',
    deploy: 'Deploy',
    basicInfo: 'Basic Information',
    pluginManagement: 'Plugin Management',
    pluginManagementTips: 'Integrate and manage extended function plugins for agents, supporting function calling and third-party service integration',
    uploadPlugin: 'Upload Plugin',
    pluginName: 'Plugin Name',
    pluginCode: 'Plugin Code',
    pluginVersion: 'Plugin Version',
    pluginType: 'Plugin Type',
    pluginStatus: 'Plugin Status',
    statusPublished: 'Published',
    statusPending: 'Pending',
    statusDisabled: 'Disabled',
    audit: 'Audit',
    hotUpdate: 'Hot Update',
    selectSession: 'Select Session',
    pleaseSelectAgent: 'Please select an agent on the left first',
    noSessions: 'No session records',
    chatDetail: 'Chat Detail',
    pleaseSelectSession: 'Please select a session',
    searchContent: 'Search chat content',
    filterSensitive: 'Filter sensitive words',
    messageCount: '{count} messages',
    pleaseSelectSessionOnLeft: 'Please select a session on the left to view details',
    noChatHistory: 'No chat history',
    noDescription: 'No description',
    fetchAgentListFailed: 'Failed to fetch agent list',
    deleteConfirm: 'Are you sure you want to delete this agent? This action cannot be undone.',
    deleteAgentConfirm: 'Are you sure you want to delete agent "{name}"? This action is irreversible.',
    statusUpdateSuccess: 'Status updated successfully',
    selectLlmModel: 'Please select an LLM model',
    selectTtsModel: 'Please select a TTS model',
    templateLoaded: 'Template loaded: {name}',
    updateSuccess: 'Updated successfully',
    createSuccess: 'Created successfully',
    deployTitle: 'Quick Deploy Agent',
    sourceTemplate: 'Source Template',
    newAgentName: 'New Agent Name',
    confirmDeploy: 'Confirm Deploy',
    unnamedTemplate: 'Unnamed Template',
    pluginCodePlaceholder: 'Enter plugin code (Provider Code)',
    pluginTypeFunction: 'Function',
    pluginTypePlugin: 'Plugin',
    fieldsDefinition: 'Fields Definition',
    fieldsDefinitionTip: 'Enter fields definition for the plugin (JSON format)',
    auditConfirm: 'Are you sure you want to approve the plugin "{name}"?',
    auditSuccess: 'Audit successful',
    inputVersion: 'Enter new version',
    versionFormatError: 'Invalid version format (e.g., 1.0.1)',
    hotUpdateTitle: 'Plugin Hot Update',
    hotUpdateSuccess: 'Hot update successful',
    fieldsJsonError: 'Fields definition must be valid JSON format',
    agentDetail: 'Agent Detail',
    unnamedAgent: 'Unnamed Agent',
    fetchDetailFailed: 'Failed to fetch agent detail',
    language: 'Language',
    langCode: 'Language Code',
    sort: 'Sort',
    creator: 'Creator',
    createdAt: 'Created At',
    updater: 'Updater',
    updatedAt: 'Updated At',
    wechatOpenid: 'WeChat OpenID',
    agentTemplateId: 'Agent Template ID',
    templateDetail: 'Template Detail',
    unnamedTemplate: 'Unnamed Template',
    fetchTemplateDetailFailed: 'Failed to fetch template detail'
  },
  system: {
    // System Config
    systemConfigTips: 'System Config',
    basicSettings: 'Basic Settings',
    systemName: 'System Name',
    enterSystemName: 'Enter System Name',
    systemVersion: 'System Version',
    companyName: 'Company Name',
    enterCompanyName: 'Enter Company Name',
    contactEmail: 'Contact Email',
    enterContactEmail: 'Enter Contact Email',
    enterValidEmail: 'Enter Valid Email',
    defaultLanguage: 'Default Language',
    chinese: 'Simplified Chinese',
    english: 'English',
    timeZone: 'Time Zone',
    gmt8ChinaTime: 'GMT+8 (China Standard Time)',
    gmt5UsEastern: 'GMT-5 (Eastern Standard Time)',
    gmt0Greenwich: 'GMT+0 (Greenwich Mean Time)',
    gmt9Japan: 'GMT+9 (Japan Standard Time)',
    securitySettings: 'Security Settings',
    passwordPolicy: 'Password Policy',
    simple: 'Simple',
    medium: 'Medium',
    strong: 'Strong',
    sessionTimeout: 'Session Timeout',
    enterSessionTimeout: 'Enter Session Timeout',
    minutes: 'Minutes',
    maxLoginAttempts: 'Max Login Attempts',
    times: 'Times',
    emailSettings: 'Email Settings',
    smtpServer: 'SMTP Server',
    enterSmtpServer: 'Enter SMTP Server',
    smtpPort: 'SMTP Port',
    enterSmtpPort: 'Enter SMTP Port',
    senderEmail: 'Sender Email',
    enterSenderEmail: 'Enter Sender Email',
    senderPassword: 'Sender Password',
    enterSenderPassword: 'Enter Sender Password',
    testEmail: 'Test Email',
    storageSettings: 'Storage Settings',
    storagePath: 'Storage Path',
    enterStoragePath: 'Enter Storage Path',
    maxFileSize: 'Max File Size',
    enterMaxFileSize: 'Enter Max File Size',
    megabytes: 'MB',
    cleanupDays: 'Cleanup Days',
    days: 'Days',
    cleanupStorage: 'Cleanup Storage',
    emailTestSuccess: 'Email Test Successful',
    emailTestFailed: 'Email Test Failed',
    cleanupSuccess: 'Storage Cleanup Successful',
    cleanupFailed: 'Storage Cleanup Failed',
    basicSettingsDesc: 'Manage basic system information, language, and time zone settings',
    securitySettingsDesc: 'Configure login policy, password strength, and session timeout',
    emailSettingsDesc: 'Configure SMTP service for system notification emails',
    storageSettingsDesc: 'Configure file storage path, quota, and auto-cleanup cycle',
    serverSettingsDesc: 'Configure server WebSocket, MQTT gateway, and security keys',
    enterServerWebsocketTip: 'WebSocket address for device connection',
    serverSettings: 'Server Settings',
    serverWebsocket: 'WebSocket Address',
    enterServerWebsocket: 'Please enter WebSocket address (separate multiple with semicolon)',
    serverSecret: 'Server Secret',
    enterServerSecret: 'Please enter server secret',
    serverMqttGateway: 'MQTT Gateway',
    enterServerMqttGateway: 'Please enter MQTT gateway address',
    serverOta: 'OTA Address',
    enterServerOta: 'Please enter OTA update address',
    allowUserRegister: 'Allow User Register',
    generateSecret: 'Generate Secret',
    initSecretSuccess: 'Secret initialization successful',
    initSecretFailed: 'Secret initialization failed',
    cleanupSuccess: 'Storage Cleanup Successful',
    cleanupFailed: 'Storage Cleanup Failed',

    // Alarm Management
    alarmManagementTips: 'Alarm Management',
    createAlarm: 'Create Alarm',
    editAlarmRule: 'Edit Alarm Rule',
    batchEnableAlarms: 'Batch Enable',
    batchDisableAlarms: 'Batch Disable',
    batchDeleteAlarms: 'Batch Delete',
    batchDeleteAlarmsConfirm: 'Are you sure you want to delete {count} selected alarm rules?',
    critical: 'Critical',
    warning: 'Warning',
    info: 'Info',
    noDescription: 'No Description',
    triggerType: 'Trigger Type',
    threshold: 'Threshold',
    duration: 'Duration',
    notificationChannels: 'Notification Channels',
    test: 'Test',
    alarmNamePlaceholder: 'Enter Alarm Name',
    selectSeverity: 'Select Severity',
    alarmDescriptionPlaceholder: 'Enter Alarm Description',
    selectTriggerType: 'Select Trigger Type',
    selectResourceType: 'Select Resource Type',
    thresholdPlaceholder: 'Enter Threshold',
    selectUnit: 'Select Unit',
    updateAlarmStatusSuccess: 'Status Updated Successfully',
    updateAlarmStatusFailed: 'Status Update Failed',
    updateAlarmSuccess: 'Updated Successfully',
    createAlarmSuccess: 'Created Successfully',
    saveAlarmFailed: 'Save Failed',
    deleteAlarmSuccess: 'Deleted Successfully',
    deleteAlarmFailed: 'Delete Failed',
    confirmDeleteAlarm: 'Are you sure you want to delete this alarm rule?',
    testAlarmSuccess: 'Alarm Test Sent Successfully',
    testAlarmFailed: 'Alarm Test Failed',
    batchEnableSuccess: 'Batch Enable Successful',
    batchEnableFailed: 'Batch Enable Failed',
    batchDisableSuccess: 'Batch Disable Successful',
    batchDisableFailed: 'Batch Disable Failed',
    batchDeleteSuccess: 'Batch Delete Successful',
    batchDeleteFailed: 'Batch Delete Failed',

    // Log Management
    logManagementTips: 'Log Management',
    export: 'Export',
    exporting: 'Exporting logs...',
    exportSuccess: 'Logs Exported Successfully',
    exportFailed: 'Logs Export Failed',
    selectLogsFirst: 'Please select logs to export first',
    batchExporting: 'Batch exporting...',
    batchExportSuccess: 'Batch Export Successful',
    batchExportFailed: 'Batch Export Failed',
    exportingSingle: 'Exporting single log...',
    exportSingleSuccess: 'Export Successful',
    exportSingleFailed: 'Export Failed',
    confirmDeleteLog: 'Are you sure you want to delete this log?',
    deleteLogSuccess: 'Deleted Successfully',
    deleteLogFailed: 'Delete Failed',
    getLogsFailed: 'Failed to Fetch Logs',
    selectLogType: 'Select Log Type',
    loginLog: 'Login Log',
    operationLog: 'Operation Log',
    errorLog: 'Error Log',
    systemLog: 'System Log',
    userOperationLog: 'User Log',
    roleOperationLog: 'Role Log',
    deviceOperationLog: 'Device Log',
    agentOperationLog: 'Agent Log',
    usernamePlaceholder: 'Enter Username',
    ipPlaceholder: 'Enter IP Address',
    to: 'To',
    startTime: 'Start Time',
    endTime: 'End Time',
    totalLogs: 'Total Logs',
    successLogs: 'Success Logs',
    failedLogs: 'Failed Logs',
    deviceId: 'Device ID',
    agentId: 'Agent ID',
    roleName: 'Role Name',
    operationStatus: 'Status',
    operationContent: 'Content',
    operationTime: 'Time',
    logDetail: 'Log Detail',
    logType: 'Log Type',
    targetType: 'Target Type',
    targetId: 'Target ID',
    userAgent: 'User Agent',

    // Log Enums
    logEnums: {
      type: {
        operation: 'Operation',
        error: 'Error',
        system: 'System',
        login: 'Login'
      },
      targetType: {
        user: 'User',
        role: 'Role',
        device: 'Device',
        agent: 'Agent',
        job: 'Job'
      },
      action: {
        USER_CREATE: 'Create User',
        USER_UPDATE: 'Update User',
        USER_DELETE: 'Delete User',
        USER_LEVEL_DOWNGRADE: 'Level Downgrade',
        CHANGE_PASSWORD: 'Change Password',
        CHANGE_PASSWORD_DIRECTLY: 'Reset Password',
        ROLE_CREATE: 'Create Role',
        ROLE_UPDATE: 'Update Role',
        ROLE_DELETE: 'Delete Role',
        DEVICE_CREATE: 'Add Device',
        DEVICE_UPDATE: 'Update Device',
        DEVICE_DELETE: 'Delete Device',
        DEVICE_BIND: 'Bind Device',
        DEVICE_UNBIND: 'Unbind Device',
        DEVICE_BATCH_OPERATION: 'Batch Device Operation',
        AGENT_CREATE: 'Create Agent',
        AGENT_UPDATE: 'Update Agent',
        AGENT_DELETE: 'Delete Agent',
        LOGIN: 'Login',
        LOGOUT: 'Logout',
        REGISTER: 'Register',
        UPLOAD_AVATAR: 'Upload Avatar'
      }
    },

    // Notification Management
    notificationManagement: 'Notification Management',
    getNotificationsFailed: 'Failed to Fetch Notifications',
    markAsReadSuccess: 'Marked as Read',
    markAsReadFailed: 'Mark Failed',
    markAsReadConfirm: 'Are you sure you want to mark this notification as read?',
    batchMarkAsReadSuccess: 'Batch Mark Read Successful',
    batchMarkAsReadFailed: 'Batch Mark Read Failed',
    batchMarkAsReadConfirm: 'Are you sure you want to mark all selected notifications as read?',
    batchMarkAsUnreadSuccess: 'Batch Mark Unread Successful',
    batchMarkAsUnreadFailed: 'Batch Mark Unread Failed',
    batchMarkAsUnreadConfirm: 'Are you sure you want to mark all selected notifications as unread?',
    deleteNotificationSuccess: 'Notification Deleted Successfully',
    deleteNotificationFailed: 'Notification Delete Failed',
    deleteNotificationConfirm: 'Are you sure you want to delete this notification?',
    batchDeleteNotificationSuccess: 'Batch Delete Successful',
    batchDeleteNotificationFailed: 'Batch Delete Failed',
    batchDeleteNotificationConfirm: 'Are you sure you want to delete all selected notifications?',
    sendNotificationSuccess: 'Notification Sent Successfully',
    sendNotificationFailed: 'Notification Send Failed',
    updateNotificationSuccess: 'Notification Updated Successfully',
    updateNotificationFailed: 'Notification Update Failed',
    selectNotificationsFirst: 'Please select notifications first',
    noUnreadNotificationsSelected: 'No unread notifications selected',
    noReadNotificationsSelected: 'No read notifications selected',
    sendNotification: 'Send Notification',
    editNotification: 'Edit Notification',
    enterNotificationTitle: 'Enter Notification Title',
    enterNotificationContent: 'Enter Notification Content',
    notificationTitleLength: 'Title length between 5 and 100 characters',
    notificationContentLength: 'Content length between 10 and 1000 characters',
    selectNotificationChannels: 'Select Notification Channels',
    enterRecipientUsername: 'Enter Recipient Username',
    allUsers: 'All Users',
    specificUser: 'Specific User',
    lowPriority: 'Low Priority',
    mediumPriority: 'Medium Priority',
    highPriority: 'High Priority',
    notificationSearchPlaceholder: 'Search Title or Content',
    selectNotificationType: 'Select Notification Type',
    selectNotificationStatus: 'Select Notification Status',
    selectNotificationPriority: 'Select Notification Priority',
    notificationTitle: 'Notification Title',
    notificationContent: 'Notification Content',
    notificationType: 'Notification Type',
    receiver: 'Receiver',
    sendTime: 'Send Time',
    status: 'Status',
    sent: 'Sent',
    pending: 'Pending',
    failed: 'Failed',
    unreadNotification: 'Unread',
    readNotification: 'Read',
    deletedNotification: 'Deleted',
    systemNotification: 'System Notification',
    alertNotification: 'Alert Notification',
    updateNotification: 'Update Notification',
    reminderNotification: 'Reminder Notification',
    infoNotification: 'Info Notification',
    markAsRead: 'Mark Read',
    channels: 'Channels',
    recipient: 'Recipient',
    
    // Notification Channel
    notificationChannelTips: 'Notification Channel Config',
    systemChannel: 'In-App Message',
    systemChannelDescription: 'Internal system messages, visible after login',
    emailChannel: 'Email Notification',
    emailChannelDescription: 'Send notifications via email',
    smtpHost: 'SMTP Host',
    enterSmtpHost: 'Enter SMTP Host',
    smtpUsername: 'SMTP Username',
    enterSmtpUsername: 'Enter SMTP Username',
    smtpPassword: 'SMTP Password',
    enterSmtpPassword: 'Enter SMTP Password',
    smtpEncryption: 'Encryption',
    selectSmtpEncryption: 'Select Encryption',
    noEncryption: 'No Encryption',
    senderName: 'Sender Name',
    enterSenderName: 'Enter Sender Name',
    smsChannel: 'SMS Notification',

    // Permission Management
    roleOperationLogTips: 'Role Operation Log',
    operator: 'Operator',
    target: 'Target',
    result: 'Result',
    detail: 'Detail',
    success: 'Success',
    fail: 'Fail',

    actions: {
      apiCallFailed: 'API Call Failed',
      permVerifyFailed: 'Permission Verification Failed',
      fileUploadFailed: 'File Upload Failed',
      emailSendFailed: 'Email Send Failed',
      userAuthFailed: 'User Authentication Failed',
      paramVerifyFailed: 'Parameter Verification Failed',
      networkTimeout: 'Network Timeout',
      userLogin: 'User Login',
      userLogout: 'User Logout',
      viewUserList: 'View User List',
      createUser: 'Create User',
      editUserInfo: 'Edit User Info',
      deleteUser: 'Delete User',
      enableUser: 'Enable User',
      disableUser: 'Disable User',
      batchDeleteUser: 'Batch Delete User',
      viewUserDetail: 'View User Detail',
      viewDeviceList: 'View Device List',
      addDevice: 'Add Device',
      editDeviceInfo: 'Edit Device Info',
      deleteDevice: 'Delete Device',
      deviceOnline: 'Device Online',
      deviceOffline: 'Device Offline',
      deviceRestart: 'Device Restart',
      firmwareUpgrade: 'Firmware Upgrade',
      bindDeviceToUser: 'Bind Device To User',
      unbindDevice: 'Unbind Device',
      viewAlarmList: 'View Alarm List',
      createAlarmRule: 'Create Alarm Rule',
      editAlarmRule: 'Edit Alarm Rule',
      deleteAlarmRule: 'Delete Alarm Rule',
      enableAlarmRule: 'Enable Alarm Rule',
      disableAlarmRule: 'Disable Alarm Rule',
      processAlarm: 'Process Alarm',
      ignoreAlarm: 'Ignore Alarm',
      viewNotificationList: 'View Notification List',
      sendNotification: 'Send Notification',
      editNotification: 'Edit Notification',
      deleteNotification: 'Delete Notification',
      batchMarkRead: 'Batch Mark Read',
      batchDeleteNotification: 'Batch Delete Notification',
      systemStartup: 'System Startup',
      systemShutdown: 'System Shutdown',
      systemRestart: 'System Restart',
      dbBackup: 'Database Backup',
      systemUpdate: 'System Update',
      clearCache: 'Clear Cache',
      systemMaintenance: 'System Maintenance'
    },
    templates: {
      loginSuccess: 'User Login Success',
      loginFromIp: 'Login from IP {ip}',
      loginVerified: 'Login Verified',
      logoutNormal: 'User Logout Normal',
      logoutTimeout: 'Session Timeout Logout',
      viewUserListDesc: 'Viewed User List Page 1',
      searchUserListDesc: 'Searched User List',
      createNewAccount: 'Created New Account',
      adminCreateUser: 'Admin Create User',
      updateUserProfile: 'Updated User Profile',
      adminModifyUser: 'Admin Modify User',
      adminDeleteUser: 'Admin Delete User',
      userDeleteAccount: 'User Delete Account',
      adminEnableUser: 'Admin Enable User',
      userStatusActivated: 'User Status Activated',
      adminDisableUser: 'Admin Disable User',
      userStatusDeactivated: 'User Status Deactivated',
      adminBatchDeleteUsers: 'Admin Batch Delete Users',
      userBatchDelete: 'Batch Delete User Operation',
      viewUserDetailDesc: 'Viewed User Detail',
      adminViewUserInfo: 'Admin View User Info',
      viewDeviceListDesc: 'Viewed Device List',
      searchDeviceListDesc: 'Searched Device List',
      addNewDevice: 'Added New Device',
      adminBindDevice: 'Admin Bind Device',
      updateDeviceInfo: 'Updated Device Info',
      adminModifyDevice: 'Admin Modify Device',
      adminDeleteDevice: 'Admin Delete Device',
      userRemoveDevice: 'User Remove Device',
      deviceConnectSuccess: 'Device Connect Success',
      deviceOnlineNotice: 'Device Online Notice',
      deviceDisconnect: 'Device Disconnect',
      deviceOfflineAlarm: 'Device Offline Alarm',
      userRestartDevice: 'User Restart Device',
      deviceExecuteRestart: 'Device Execute Restart',
      firmwareUpgradeTo: 'Firmware Upgrade To Version {version}',
      userUpgradeFirmware: 'User Upgrade Firmware',
      adminBindToUser: 'Admin Bind Device To User',
      userBindDevice: 'User Bind Device',
      adminUnbindDevice: 'Admin Unbind Device',
      userUnbindDevice: 'User Unbind Device',
      viewAlarmListDesc: 'Viewed Alarm List',
      filterAlarmRecords: 'Filtered Alarm Records',
      createNewAlarmRule: 'Created New Alarm Rule',
      adminAddAlarmMonitor: 'Admin Add Alarm Monitor'
    }
  },
  cmsAsset: {
    pageTip: 'Manage and organize media and document assets centrally',
    uploadAsset: 'Upload Asset',
    sidebarTitle: 'Theme Categories',
    searchThemePlaceholder: 'Search themes...',
    allAssets: 'All Assets',
    assetNamePlaceholder: 'Asset Name',
    assetTypePlaceholder: 'Asset Type',
    assetStatusPlaceholder: 'Asset Status',
    typeAudio: 'Audio',
    typeVideo: 'Video',
    typeImage: 'Image',
    typeBgm: 'BGM',
    typeText: 'Text',
    typePdf: 'PDF',
    typeOther: 'Other',
    statusNormal: 'Normal',
    statusProcessing: 'Processing',
    statusAbnormal: 'Abnormal',
    statusThumbFailTip: 'Thumbnail generation failed. Please check FFmpeg environment',
    query: 'Search',
    reset: 'Reset',
    preview: 'Preview',
    name: 'Name',
    type: 'Type',
    status: 'Status',
    size: 'Size',
    uploadTime: 'Upload Time',
    action: 'Action',
    viewDetail: 'Detail',
    delete: 'Delete',
    cardEmpty: 'No assets under this theme',
    batchSelectedCount: '{count} assets selected',
    confirmBatchDeleteCount: 'Are you sure you want to delete {count} selected assets? This action cannot be undone',
    batchDelete: 'Batch Delete',
    cancelSelection: 'Cancel Selection',
    dialogEditTitle: 'Edit Asset',
    dialogUploadTitle: 'Upload Asset',
    fieldName: 'Name',
    fieldTheme: 'Theme',
    fieldThemePlaceholder: 'Select theme',
    fieldDescription: 'Description',
    fieldDescriptionPlaceholder: 'Enter asset description',
    fieldSelectFile: 'Select Files',
    uploadDragText: 'Drag files here or click to upload',
    uploadTip: 'Multiple formats supported. Thumbnails will be generated automatically',
    cancel: 'Cancel',
    confirm: 'Confirm',
    pleaseSelectFile: 'Please select files',
    updateSuccess: 'Updated successfully',
    updateFailed: 'Update failed',
    allUploadedSuccess: 'All files uploaded successfully',
    partialUploadFailed: 'Some assets failed to upload',
    assetProcessFailed: 'Asset processing failed',
    confirmDeleteAsset: 'Are you sure you want to delete this asset? This action cannot be undone',
    warning: 'Warning',
    deleteSuccess: 'Deleted successfully',
    loadListFailed: 'Failed to load asset list',
    getThemeFailed: 'Failed to fetch themes',
    uploadingStatus: 'Uploading ({current}/{total}): {filename}'
  },
  cmsTheme: {
    pageTip: 'Create and manage theme categories to organize your asset library',
    createTheme: 'Create Theme',
    searchPlaceholder: 'Search name or description...',
    query: 'Search',
    reset: 'Reset',
    preview: 'Preview',
    themeName: 'Theme Name',
    physicalPath: 'Physical Path',
    assetCount: 'Asset Count',
    createDate: 'Created Date',
    action: 'Action',
    viewDetail: 'Detail',
    edit: 'Edit',
    delete: 'Delete',
    badgeAssetCount: '{count} assets',
    noDescription: 'No description',
    emptyDesc: 'No themes yet. Create your first theme',
    dialogCreateTitle: 'Create New Theme',
    dialogEditTitle: 'Edit Theme',
    fieldThemeName: 'Theme Name',
    fieldThemeNamePlaceholder: 'Give your theme a catchy name',
    fieldThemeIcon: 'Theme Icon',
    fieldThemeIconPlaceholder: 'Image URL or upload image',
    upload: 'Upload',
    fieldCardColor: 'Card Background',
    fieldSort: 'Sort',
    fieldPhysicalPath: 'Physical Path',
    fieldPhysicalPathPlaceholder: 'Folder name, e.g., nature_2024',
    fieldPhysicalPathHelp: 'Leave empty to use theme name. Use letters/numbers/underscore.',
    fieldDescription: 'Theme Description',
    fieldDescriptionPlaceholder: 'Briefly describe the theme...',
    cancel: 'Cancel',
    confirm: 'Confirm',
    danger: 'Danger',
    confirmDeleteWithName: 'Are you sure you want to delete theme "{name}"?',
    deleteWithFiles: 'Also delete the physical folder on the server and all its assets',
    confirmDelete: 'Delete',
    imageUploadSuccess: 'Image uploaded successfully',
    uploadFailed: 'Upload failed',
    saveSuccess: 'Saved successfully',
    saveFailed: 'Save failed',
    deleteSuccess: 'Deleted successfully',
    fetchListFailed: 'Failed to fetch theme list',
    validationThemeNameRequired: 'Please enter theme name',
    validationPhysicalPathPattern: 'Only letters, numbers and underscore are allowed'
  },
  cmsTag: {
    pageTip: 'Manage content asset tags with drag-and-drop ordering',
    addTag: 'Add Tag',
    searchPlaceholder: 'Search tag name...',
    tagName: 'Tag Name',
    createTime: 'Created Time',
    action: 'Action',
    edit: 'Edit',
    delete: 'Delete',
    tipDragSort: 'Tip: Drag rows to manually sort',
    totalCount: 'Total {count} tags',
    dialogCreateTitle: 'Add Tag',
    dialogEditTitle: 'Edit Tag',
    fieldTagName: 'Tag Name',
    fieldTagNamePlaceholder: 'Enter tag name',
    fieldSort: 'Sort',
    cancel: 'Cancel',
    confirm: 'Confirm',
    fetchListFailed: 'Failed to fetch tag list',
    sortUpdateSuccess: 'Sort updated successfully',
    sortUpdateFailed: 'Failed to update sort',
    searchDragDisabled: 'Sorting is disabled while searching',
    deleteConfirm: 'Are you sure you want to delete tag "{name}"? This action is irreversible.',
    confirmDelete: 'Confirm',
    cancelDelete: 'Cancel',
    deleteSuccess: 'Tag deleted successfully',
    deleteFailed: 'Failed to delete tag',
    updateSuccess: 'Tag updated successfully',
    createSuccess: 'Tag created successfully',
    operationFailed: 'Operation failed',
    validationNameRequired: 'Tag name is required',
    validationNameLength: 'Length must be between 1 and 20 characters'
  },
  cmsThemeDetail: {
    titlePrefix: 'Theme',
    assetStats: 'Asset Stats',
    totalFiles: 'Total Files',
    totalSize: 'Total Size',
    typeDistribution: 'Type Distribution',
    noAssets: 'No assets',
    basicInfo: 'Basic Information',
    displayColor: 'Display Color',
    deleteTheme: 'Delete Theme',
    saveChanges: 'Save Changes',
    renameFolderTip: 'Changing the physical path will rename the folder on disk',
    confirmPermanentDelete: 'Are you sure you want to permanently delete theme "{name}"?',
    validationPhysicalPathRequired: 'Please enter physical path',
    validationPhysicalPathPatternLower: 'Path can only contain lowercase letters, numbers and underscore',
    fetchDetailFailed: 'Failed to fetch details'
  },
  cmsAssetDetail: {
    titlePrefix: 'Asset',
    previewAndCover: 'Preview & Cover',
    replaceCover: 'Replace Cover',
    previewOriginal: 'Preview Original',
    tagManagement: 'Tag Management',
    manage: 'Manage',
    inputTagPlaceholder: 'Enter tag',
    addTag: 'Add Tag',
    assetProperties: 'Asset Properties',
    format: 'Format',
    uuid: 'UUID',
    techParams: 'Technical Parameters',
    assetDescription: 'Asset Description',
    descriptionPlaceholder: 'Please enter detailed description...',
    saved: 'Saved',
    saveChanges: 'Save Changes',
    videoOriginalSize: 'Original Size',
    videoAdaptive: 'Fit',
    playbackRate: 'Speed:',
    unsupportedPreview: 'This type is not supported for advanced preview',
    escTip: 'Press ESC to quickly close',
    download: 'Download',
    fetchDetailFailed: 'Failed to fetch asset details',
    thumbTooLarge: 'Cover image must be smaller than 2MB',
    cropDataFailed: 'Failed to get crop data',
    thumbUpdateSuccess: 'Cover updated successfully',
    serverNoThumb: 'Server did not return a thumbnail URL',
    thumbUpdateFailed: 'Failed to replace cover',
    meta: {
      duration: 'Duration',
      resolution: 'Resolution',
      bitrate: 'Bitrate',
      codec: 'Codec',
      durationSeconds: 'Duration (seconds)'
    }
  }
,
  product: {
    pageDesc: 'Product Archive Management: Manage basic metadata for all physical factory devices',
    addProduct: 'Add Product',
    allProducts: 'All Products',
    smartDevice: 'Smart Device',
    peripheralAccessory: 'Peripheral Accessory',
    searchPlaceholder: 'Device Code/Name/SKU',
    productType: 'Product Type',
    deviceCategory: 'Device Category',
    peripheralType: 'Peripheral Type',
    productId: 'Product ID',
    deviceCode: 'Device Code (UUID)',
    snCode: 'Unique Identifier (SN)',
    productName: 'Product Name',
    skuCode: 'SKU Code',
    productImage: 'Product Image',
    warrantyMonths: 'Warranty (Months)',
    editProductArchive: 'Edit Product Archive',
    addProductArchive: 'Add Product Archive',
    snCodePlaceholder: 'Factory Unique Physical Code/SN',
    batchNo: 'Batch No.',
    batchNoPlaceholder: 'Filter by batch no.',
    activationTime: 'Activation Time',
    factory: 'Factory',
    productDescription: 'Product Description',
    snCodeRequired: 'Device unique physical identifier cannot be empty',
    productNameRequired: 'Product name cannot be empty',
    skuCodeRequired: 'SKU code cannot be empty',
    productTypeRequired: 'Product type cannot be empty',
    productDetail: 'Product Detail',
    deleteProduct: 'Delete Product',
    basicInfo: 'Basic Info',
    coreInfo: 'Core Info',
    productionAndExtraInfo: 'Production & Extra Info',
    productLine: 'Product Line',
    extraAttributes: 'Extra Attributes (JSON)',
    priceStrategy: 'Price Strategy',
    priceStrategyDeveloping: 'Price strategy feature is in development...',
    priceStrategyDesc: 'Future support for setting suggested retail price, cost price, and sales prices across different channels',
    inventoryStatus: 'Inventory Status',
    salesStatus: 'Sales Status',
    onSale: 'On Sale',
    stopSale: 'Stop Sale',
    preSale: 'Pre Sale',
    lifecycleStatus: 'Lifecycle',
    planning: 'Planning',
    developing: 'Developing',
    inProduction: 'In Production',
    eol: 'End of Life',
    warehouseId: 'Current Warehouse ID',
    productOwner: 'Product Owner',
    operationLog: 'Operation Log',
    operationLogDeveloping: 'Operation log feature is in development...',
    operationLogDesc: 'Future display of history records including creation, modification, and status changes of this product',
    fetchDetailFailed: 'Failed to fetch product detail',
    productDeleted: 'Product has been deleted',
    enterFactory: 'Please enter factory',
    enterProductLine: 'Please enter product line',
    enterExtraAttributes: 'Please enter JSON format extra attributes',
    selectLifecycleStatus: 'Please select lifecycle status',
    enterWarehouseId: 'Please enter warehouse ID',
    enterOwner: 'Please enter owner name',
    categoryRequired: 'Category cannot be empty',
    checkBasicInfo: 'Please check required fields in basic info tab',
    invalidJsonFormat: 'Extra attributes must be valid JSON format',
    confirmDeletePrefix: 'Are you sure you want to delete product "',
    confirmDeleteSuffix: '"? This action cannot be undone.',
    confirmDeleteButton: 'Confirm Delete',
    loading: 'Loading...',
    noProductData: 'No product data'
  },
  peripheral: {
    pageDesc: 'Manage NFC card swipe records, binding status and activation records',
    addPeripheral: 'Add NFC Card',
    searchPlaceholder: 'NFC UUID/SKU Code',
    peripheralTypePlaceholder: 'Card Type',
    bindingStatusPlaceholder: 'Binding Status',
    bindingStatus: 'Binding Status',
    bound: 'Bound',
    unbound: 'Unbound',
    deviceUuid: 'NFC UUID',
    deviceName: 'Device Name',
    peripheralType: 'Card Type',
    unknown: 'Unknown',
    bindUser: 'Bound User',
    bindTime: 'Bind Time',
    activationTime: 'Activation Time',
    remark: 'Remark',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    operation: 'Operation',
    view: 'View',
    edit: 'Edit',
    bindUnbind: 'Bind/Unbind',
    delete: 'Delete',
    batchDelete: 'Batch Delete',
    refresh: 'Refresh',
    query: 'Query',
    reset: 'Reset',
    selectedItems: '{count} items selected',
    cancelSelection: 'Cancel Selection',
    bindUnbindUser: 'Bind/Unbind User',
    currentBind: 'Current Bind',
    selectUser: 'Select User',
    selectUserPlaceholder: 'Please select user',
    cancel: 'Cancel',
    unbind: 'Unbind',
    bind: 'Bind',
    confirmBatchDelete: 'Are you sure to delete the selected {count} items?',
    warning: 'Warning',
    confirmDelete: 'Are you sure to delete this NFC card record?',
    tips: 'Tips',
    deleteSuccess: 'Deleted successfully',
    bindSuccess: 'Bound successfully',
    unbindSuccess: 'Unbound successfully',
    peripheralDetail: 'NFC Card Detail',
    basicInfo: 'Basic Info',
    deviceCode: 'Device Code',
    macAddress: 'MAC Address',
    bindingInfo: 'Binding Info',
    productCategory: 'Product Category',
    modifyRemark: 'Modify Remark',
    confirmUnbind: 'Are you sure to unbind the user?',
    statusInfo: 'Status Info',
    dataStatus: 'Data Status',
    normal: 'Normal',
    abnormal: 'Abnormal',
    peripheralOperations: 'NFC Card Operations',
    refreshInfo: 'Refresh Info',
    backToList: 'Back to List',
    remarkInfo: 'Remark Info',
    noRemark: 'No remark',
    editRemark: 'Edit',
    save: 'Save',
    nfcCard: 'NFC Card',
    peripheralTypeLabel: 'Card Type',
    deviceNameLabel: 'Device Name',
    deviceCodeLabel: 'Device Code',
    macAddressLabel: 'MAC Address',
    remarkLabel: 'Remark',
    bindTimeLabel: 'Bind Time',
    createTimeLabel: 'Create Time',
    updateTimeLabel: 'Update Time',
    creator: 'Creator',
    updater: 'Updater',
    currentBindStatus: 'Current Binding Status',
    userId: 'User ID',
    userName: 'Username',
    uuid: 'UUID'
  },
  activity: {
    title: 'Activity Title',
    subtitle: 'Activity Subtitle',
    coverImage: 'Cover Image',
    category: 'Category',
    categoryOnline: 'Online',
    categoryOffline: 'Offline',
    categoryPromotion: 'Promotion',
    categoryCommunity: 'Community',
    categoryOther: 'Other',
    status: 'Status',
    statusDraft: 'Draft',
    statusPublished: 'Published',
    statusArchived: 'Archived',
    statusCanceled: 'Canceled',
    isTop: 'Top Display',
    publishTime: 'Publish Time',
    activityStartTime: 'Start Time',
    activityEndTime: 'End Time',
    activityLocation: 'Location',
    content: 'Content',
    activityLink: 'Activity Link',
    organizer: 'Organizer',
    contactInfo: 'Contact Info',
    maxParticipants: 'Max Participants',
    currentParticipants: 'Current Participants',
    viewCount: 'Views',
    likeCount: 'Likes',
    favoriteCount: 'Favorites',
    tags: 'Tags',
    images: 'Images',
    imageCaption: 'Caption',
    remark: 'Remark',
    publishActivity: 'Publish Activity',
    editActivity: 'Edit Activity',
    activityDetail: 'Activity Detail',
    saveDraft: 'Save Draft',
    submit: 'Submit',
    changeStatus: 'Change Status',
    targetStatus: 'Target Status',
    totalActivities: 'Total',
    draftCount: 'Draft',
    publishedCount: 'Published',
    archivedCount: 'Archived',
    canceledCount: 'Canceled',
    topDisplayCount: 'Top Display',
    searchPlaceholder: 'Search activity title',
    categoryPlaceholder: 'Select category',
    statusPlaceholder: 'Select status',
    dateRangePlaceholder: 'Select date range',
    uploadCover: 'Upload Cover',
    changeCover: 'Change Cover',
    addImage: 'Add Image',
    insertLink: 'Insert Link',
    insertImage: 'Insert Image',
    linkUrl: 'Link URL',
    linkText: 'Link Text',
    deleteConfirm: 'Are you sure to delete this activity?',
    statusChangeSuccess: 'Status changed successfully',
    deleteSuccess: 'Deleted successfully',
    saveDraftSuccess: 'Draft saved successfully',
    createSuccess: 'Published successfully',
    updateSuccess: 'Updated successfully',
    uploadFail: 'Upload failed',
    noLimit: 'No Limit',
    tagsPlaceholder: 'Separate tags with commas'
  },
  memorial: {
    title: 'Memorial Title',
    subtitle: 'Subtitle',
    icon: 'Memorial Icon',
    thumbnail: 'Thumbnail',
    backgroundImage: 'Background Image',
    seriesName: 'Series',
    memorialType: 'Memorial Type',
    activityId: 'Related Activity',
    checkInLocation: 'Check-in Location',
    checkInTime: 'Check-in Time',
    antiFakeCode: 'Anti-fake Code',
    description: 'Description',
    acquireCondition: 'Acquire Condition',
    usageInstruction: 'Usage Instruction',
    status: 'Status',
    statusDraft: 'Draft',
    statusPublished: 'Published',
    statusExpired: 'Expired',
    statusDisabled: 'Disabled',
    acquireStatus: 'Acquire Status',
    acquireAvailable: 'Available',
    acquireAcquired: 'Acquired',
    acquireExpired: 'Expired',
    visibility: 'Visibility',
    visibilityPublic: 'Public',
    visibilityPrivate: 'Private',
    visibilityActivityOnly: 'Activity Only',
    acquirePermission: 'Acquire Permission',
    permissionAll: 'All Users',
    permissionActivityUser: 'Activity Participants',
    permissionInvited: 'Invited Users',
    acquireCount: 'Acquire Count',
    shareCount: 'Share Count',
    sortOrder: 'Sort Order',
    remark: 'Remark',
    createMemorial: 'Create Memorial',
    editMemorial: 'Edit Memorial',
    saveDraft: 'Save Draft',
    submit: 'Submit',
    changeStatus: 'Change Status',
    targetStatus: 'Target Status',
    totalMemorials: 'Total',
    draftCount: 'Draft',
    publishedCount: 'Published',
    expiredCount: 'Expired',
    disabledCount: 'Disabled',
    deleteConfirm: 'Are you sure to delete this memorial?',
    deleteSuccess: 'Deleted successfully',
    statusChangeSuccess: 'Status changed successfully',
    saveDraftSuccess: 'Draft saved successfully',
    createSuccess: 'Created successfully',
    updateSuccess: 'Updated successfully',
    uploadFail: 'Upload failed',
    seriesAnniversary: 'Anniversary',
    seriesFestival: 'Festival',
    seriesEvent: 'Event',
    seriesAchievement: 'Achievement',
    seriesLimited: 'Limited',
    typeBadge: 'Badge',
    typeSticker: 'Sticker',
    typeStamp: 'Stamp',
    typeMedal: 'Medal',
    typeCertificate: 'Certificate'
  },
  rightsShop: {
    title: 'Rights Shop',
    exchangeRecords: 'Exchange Records',
    createRights: 'Create Rights',
    editRights: 'Edit Rights',
    rightsName: 'Rights Name',
    rightsIcon: 'Rights Icon',
    rightsType: 'Rights Type',
    rightsTypeTicket: 'Ticket',
    rightsTypeExperience: 'Experience',
    rightsTypeHidden: 'Hidden',
    exchangePoints: 'Exchange Points',
    levelLimit: 'Level Limit',
    stockQuantity: 'Stock Quantity',
    dailyExchangeLimit: 'Daily Exchange Limit',
    perUserLimit: 'Per User Limit',
    validityPeriod: 'Validity Period',
    supportRefund: 'Support Refund',
    status: 'Status',
    statusDraft: 'Draft',
    statusPending: 'Pending',
    statusOnline: 'Online',
    statusOffline: 'Offline',
    totalRights: 'Total Rights',
    totalExchanged: 'Total Exchanged',
    exchangeStatusUnused: 'Unused',
    exchangeStatusUsed: 'Used',
    exchangeStatusExpired: 'Expired',
    exchangeStatusCancelled: 'Cancelled',
    pointsExchange: 'Points Exchange',
    exchangeSuccess: 'Exchange Success',
    exchangeFail: 'Exchange Failed',
    cancelExchange: 'Cancel Exchange',
    useExchange: 'Use/Verify',
    cancelSuccess: 'Cancelled, points refunded',
    useSuccess: 'Verified successfully'
  }
};
